import { defineComponent as C, createVNode as e, openBlock as o, createElementBlock as r, createElementVNode as n, createStaticVNode as m } from "vue";
const O = "d";
function h(t, l) {
  return l ? typeof l == "string" ? ` ${t}--${l} ` : Array.isArray(l) ? l.reduce((c, d) => c + h(t, d), "") : Object.keys(l).reduce(
    (c, d) => c + (l[d] ? h(t, d) : ""),
    ""
  ) : "";
}
function z(t) {
  return (l, c) => (l && typeof l != "string" && (c = l, l = ""), l = l ? `${t}__${l}` : t, `${l}${h(l, c)}`);
}
function S(t) {
  const l = `${O}-${t}`;
  return [l, z(l)];
}
const B = {
  color: {
    type: String,
    default: "inherit"
  },
  size: {
    type: String,
    default: "medium"
  },
  class: {
    type: String,
    default: ""
  },
  className: {
    type: String,
    default: ""
  },
  spin: {
    type: Boolean,
    default: !1
  },
  rotate: {
    type: Number,
    default: 0
  },
  onClick: {
    type: Function
  }
}, [A, H] = S("icon"), V = C({
  name: A,
  props: B,
  emits: ["click"],
  setup(t, {
    emit: l,
    attrs: c,
    slots: d
  }) {
    return () => {
      var _, v;
      const {
        color: w,
        size: i,
        spin: f,
        className: g,
        rotate: $
      } = t, p = [H({
        [i]: i,
        spin: f
      }), g, t.class, c == null ? void 0 : c.class].join(""), a = !["small", "medium", "large"].includes(i), x = {
        width: a ? i : void 0,
        height: a ? i : void 0,
        color: w,
        transform: `rotate(${$}deg)`
      };
      function M(u) {
        l("click", u);
      }
      const k = (v = (_ = d.default) == null ? void 0 : _.call(d)) == null ? void 0 : v.map((u) => ({
        ...u,
        props: {
          ...u.props,
          style: x
        }
      }));
      return e("span", {
        class: p,
        onClick: M
      }, [k]);
    };
  }
});
var L = function(t) {
  return t.replace(/(-\w)/g, function(l) {
    return l.substring(1, 2).toUpperCase();
  }).replace(/^(\w)/, function(l) {
    return l.toUpperCase();
  });
};
function j(t) {
  return t.install = (l) => {
    const { name: c } = t;
    l.component(c, t), l.component(L(c), t);
  }, t;
}
const s = j(V), F = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, q = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m0-18.565c-4.723 0-8.565 3.842-8.565 8.565S7.277 20.565 12 20.565s8.565-3.843 8.565-8.565c0-4.723-3.843-8.565-8.565-8.565"
}, null, -1), y = [
  q
];
function b(t, l) {
  return o(), r("svg", F, [...y]);
}
const T = { render: b }, D = (t) => e(s, t, {
  default: () => [e(T, null, null)]
}), Z = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, R = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "nonzero",
  d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm0 1.5H5a.5.5 0 0 0-.492.41L4.5 5v14a.5.5 0 0 0 .41.492L5 19.5h14a.5.5 0 0 0 .492-.41L19.5 19V5a.5.5 0 0 0-.41-.492z"
}, null, -1), P = [
  R
];
function I(t, l) {
  return o(), r("svg", Z, [...P]);
}
const N = { render: I }, E = (t) => e(s, t, {
  default: () => [e(N, null, null)]
}), U = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, W = /* @__PURE__ */ n("g", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero"
}, [
  /* @__PURE__ */ n("path", { d: "M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m0-18.565c-4.723 0-8.565 3.842-8.565 8.565S7.277 20.565 12 20.565s8.565-3.843 8.565-8.565c0-4.723-3.843-8.565-8.565-8.565" }),
  /* @__PURE__ */ n("path", { d: "M16.799 9.348a.714.714 0 0 0-1.01.006l-5.208 5.264-2.305-2.369a.714.714 0 1 0-1.024.996l2.813 2.89q.002.003.006.005l.003.006c.045.044.101.071.154.101.028.015.05.04.078.052a.7.7 0 0 0 .538.001c.027-.011.049-.034.075-.049.054-.03.11-.056.155-.101l.005-.006.005-.004 5.72-5.781a.715.715 0 0 0-.005-1.011" })
], -1), G = [
  W
];
function J(t, l) {
  return o(), r("svg", U, [...G]);
}
const Q = { render: J }, K = (t) => e(s, t, {
  default: () => [e(Q, null, null)]
}), X = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Y = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M17.766 8.23a.785.785 0 0 0-1.115.006l-5.75 5.84-2.547-2.628a.786.786 0 0 0-1.115-.016.795.795 0 0 0-.016 1.12l3.107 3.208q.002.002.006.005.002.002.004.006c.05.05.111.08.17.113.03.016.055.044.086.057a.78.78 0 0 0 .594.001c.03-.013.054-.038.083-.054.06-.033.12-.062.171-.112l.005-.007.006-.004 6.317-6.415a.796.796 0 0 0-.006-1.12"
}, null, -1), t1 = [
  Y
];
function e1(t, l) {
  return o(), r("svg", X, [...t1]);
}
const n1 = { render: e1 }, l1 = (t) => e(s, t, {
  default: () => [e(n1, null, null)]
}), o1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, r1 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m0-1.435c4.723 0 8.565-3.842 8.565-8.565S16.723 3.435 12 3.435 3.435 7.278 3.435 12c0 4.723 3.843 8.565 8.565 8.565m3.067-4.477-3.07-3.08-3.082 3.049a.714.714 0 1 1-1.004-1.016l3.077-3.044L7.921 8.92A.714.714 0 1 1 8.933 7.91l3.071 3.081 3.081-3.049A.714.714 0 1 1 16.09 8.96l-3.078 3.044 3.066 3.077a.714.714 0 1 1-1.011 1.008"
}, null, -1), s1 = [
  r1
];
function c1(t, l) {
  return o(), r("svg", o1, [...s1]);
}
const d1 = { render: c1 }, i1 = (t) => e(s, t, {
  default: () => [e(d1, null, null)]
}), u1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, h1 = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ n("path", { d: "m6 6 12 12M6 18 18 6" })
], -1), a1 = [
  h1
];
function _1(t, l) {
  return o(), r("svg", u1, [...a1]);
}
const v1 = { render: _1 }, w1 = (t) => e(s, t, {
  default: () => [e(v1, null, null)]
}), f1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, g1 = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ n("path", { d: "M17.5 19 11 12.5 17.5 6" }),
  /* @__PURE__ */ n("path", { d: "M12.5 19 6 12.5 12.5 6" })
], -1), $1 = [
  g1
];
function p1(t, l) {
  return o(), r("svg", f1, [...$1]);
}
const x1 = { render: p1 }, M1 = (t) => e(s, t, {
  default: () => [e(x1, null, null)]
}), k1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, C1 = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ n("path", { d: "m6 19 6.5-6.5L6 6" }),
  /* @__PURE__ */ n("path", { d: "m11 19 6.5-6.5L11 6" })
], -1), m1 = [
  C1
];
function O1(t, l) {
  return o(), r("svg", k1, [...m1]);
}
const z1 = { render: O1 }, S1 = (t) => e(s, t, {
  default: () => [e(z1, null, null)]
}), B1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, A1 = /* @__PURE__ */ n("path", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M19 15.5 12.5 9 6 15.5"
}, null, -1), H1 = [
  A1
];
function V1(t, l) {
  return o(), r("svg", B1, [...H1]);
}
const L1 = { render: V1 }, j1 = (t) => e(s, t, {
  default: () => [e(L1, null, null)]
}), F1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, q1 = /* @__PURE__ */ n("path", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m9 19 6.5-6.5L9 6"
}, null, -1), y1 = [
  q1
];
function b1(t, l) {
  return o(), r("svg", F1, [...y1]);
}
const T1 = { render: b1 }, D1 = (t) => e(s, t, {
  default: () => [e(T1, null, null)]
}), Z1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, R1 = /* @__PURE__ */ n("path", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m5.75 9.25 6.5 6.5 6.5-6.5"
}, null, -1), P1 = [
  R1
];
function I1(t, l) {
  return o(), r("svg", Z1, [...P1]);
}
const N1 = { render: I1 }, E1 = (t) => e(s, t, {
  default: () => [e(N1, null, null)]
}), U1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, W1 = /* @__PURE__ */ n("path", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M15.5 19 9 12.5 15.5 6"
}, null, -1), G1 = [
  W1
];
function J1(t, l) {
  return o(), r("svg", U1, [...G1]);
}
const Q1 = { render: J1 }, K1 = (t) => e(s, t, {
  default: () => [e(Q1, null, null)]
}), X1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Y1 = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /* @__PURE__ */ n("path", { d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ n("path", {
    fill: "currentColor",
    "fill-opacity": ".85",
    d: "M13.596 7.322c2.26-2.072 5.904-.468 5.904 2.597 0 .935-.371 1.83-1.032 2.492L12 18.879 5.532 12.41A3.52 3.52 0 0 1 4.5 9.919c0-3.065 3.644-4.669 5.904-2.597L12 8.785zM3 9.919c0 1.333.53 2.61 1.471 3.552l7.31 7.31c.121.121.317.121.438 0l7.31-7.31A5.02 5.02 0 0 0 21 9.92c0-4.37-5.196-6.656-8.418-3.703L12 6.75l-.582-.534C8.196 3.263 3 5.548 3 9.92"
  })
], -1), t0 = [
  Y1
];
function e0(t, l) {
  return o(), r("svg", X1, [...t0]);
}
const n0 = { render: e0 }, l0 = (t) => e(s, t, {
  default: () => [e(n0, null, null)]
}), o0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, r0 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "m9.779 3.25-.719 1.5H3.053c-.176 0-.303.12-.303.25v10.252l3.997-3.796a.75.75 0 0 1 .97-.053l2.082 1.582.623-.69 3.294 4.744-.967 3.71-9.696.001c-.988 0-1.803-.775-1.803-1.75V5c0-.975.815-1.75 1.803-1.75zm11.168 0c.988 0 1.803.775 1.803 1.75v14c0 .927-.736 1.672-1.656 1.744l-.147.006h-6.12L16 17.04l-4.265-6.2.76-.842a.75.75 0 0 1 .998-.105l7.757 5.635V5c0-.13-.127-.25-.303-.25H10.881l.868-1.5zM7 6.75c.356 0 .686.118.948.318l-.557 1.16.98.705A1.55 1.55 0 0 1 7 9.75c-.842 0-1.54-.663-1.54-1.5s.698-1.5 1.54-1.5"
}, null, -1), s0 = [
  r0
];
function c0(t, l) {
  return o(), r("svg", o0, [...s0]);
}
const d0 = { render: c0 }, i0 = (t) => e(s, t, {
  default: () => [e(d0, null, null)]
}), u0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, h0 = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ n("path", {
    "stroke-linecap": "round",
    d: "M2 5c0-.552.471-1 1.053-1h17.894C21.53 4 22 4.448 22 5v14c0 .552-.471 1-1.053 1H3.053C2.47 20 2 19.552 2 19z"
  }),
  /* @__PURE__ */ n("path", {
    "stroke-linecap": "round",
    d: "M7 9c.436 0 .79-.336.79-.75S7.435 7.5 7 7.5s-.79.336-.79.75S6.565 9 7 9"
  }),
  /* @__PURE__ */ n("path", {
    fill: "currentColor",
    "fill-rule": "nonzero",
    d: "m7.263 12 2.632 2 3.158-3.5L22 17v2c0 .552-.471 1-1.053 1H3.053C2.47 20 2 19.552 2 19v-2z"
  })
], -1), a0 = [
  h0
];
function _0(t, l) {
  return o(), r("svg", u0, [...a0]);
}
const v0 = { render: _0 }, w0 = (t) => e(s, t, {
  default: () => [e(v0, null, null)]
}), f0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, g0 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M12.214 2.1c5.385 0 9.75 4.366 9.75 9.75a.75.75 0 0 1-1.5 0 8.25 8.25 0 0 0-8.25-8.25.75.75 0 1 1 0-1.5"
}, null, -1), $0 = [
  g0
];
function p0(t, l) {
  return o(), r("svg", f0, [...$0]);
}
const x0 = { render: p0 }, M0 = (t) => e(s, t, {
  default: () => [e(x0, null, null)]
}), k0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, C0 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M2.79 11.462a.75.75 0 0 1 .75.75 8.25 8.25 0 0 0 8.25 8.25.75.75 0 1 1 0 1.5c-5.385 0-9.75-4.365-9.75-9.75a.75.75 0 0 1 .75-.75m9.424-9.361c5.385 0 9.75 4.365 9.75 9.75a.75.75 0 0 1-1.5 0 8.25 8.25 0 0 0-8.25-8.25.75.75 0 1 1 0-1.5"
}, null, -1), m0 = [
  C0
];
function O0(t, l) {
  return o(), r("svg", k0, [...m0]);
}
const z0 = { render: O0 }, S0 = (t) => e(s, t, {
  default: () => [e(z0, null, null)]
}), B0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, A0 = /* @__PURE__ */ n("path", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M12 2 8.942 8.239 2 9.246l5.03 4.917L5.826 21 12 17.71 18.173 21l-1.194-6.837L22 9.246l-6.904-1.007z"
}, null, -1), H0 = [
  A0
];
function V0(t, l) {
  return o(), r("svg", B0, [...H0]);
}
const L0 = { render: V0 }, j0 = (t) => e(s, t, {
  default: () => [e(L0, null, null)]
}), F0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, q0 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M12.714 17a.714.714 0 1 1-1.428 0v-6.429a.714.714 0 1 1 1.428 0zM12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2m0 1.435c-4.723 0-8.565 3.842-8.565 8.565S7.277 20.565 12 20.565s8.565-3.843 8.565-8.565c0-4.723-3.843-8.565-8.565-8.565m0 2.85a1.071 1.071 0 1 1 0 2.143 1.071 1.071 0 0 1 0-2.142"
}, null, -1), y0 = [
  q0
];
function b0(t, l) {
  return o(), r("svg", F0, [...y0]);
}
const T0 = { render: b0 }, D0 = (t) => e(s, t, {
  default: () => [e(T0, null, null)]
}), Z0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, R0 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "m8.568 13.807 2.69-3.94a1 1 0 0 1 1.663.017l2.57 3.94a1 1 0 0 1-.837 1.547h-5.26a1 1 0 0 1-.826-1.564"
}, null, -1), P0 = [
  R0
];
function I0(t, l) {
  return o(), r("svg", Z0, [...P0]);
}
const N0 = { render: I0 }, E0 = (t) => e(s, t, {
  default: () => [e(N0, null, null)]
}), U0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, W0 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "m11.172 15.432 3.94-2.69a1 1 0 0 0-.018-1.663l-3.94-2.57a1 1 0 0 0-1.546.837v5.26a1 1 0 0 0 1.564.826"
}, null, -1), G0 = [
  W0
];
function J0(t, l) {
  return o(), r("svg", U0, [...G0]);
}
const Q0 = { render: J0 }, K0 = (t) => e(s, t, {
  default: () => [e(Q0, null, null)]
}), X0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Y0 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "m8.568 10.193 2.69 3.94a1 1 0 0 0 1.663-.017l2.57-3.94a1 1 0 0 0-.837-1.547h-5.26a1 1 0 0 0-.826 1.564"
}, null, -1), t5 = [
  Y0
];
function e5(t, l) {
  return o(), r("svg", X0, [...t5]);
}
const n5 = { render: e5 }, l5 = (t) => e(s, t, {
  default: () => [e(n5, null, null)]
}), o5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, r5 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "m12.752 15.432-3.94-2.69a1 1 0 0 1 .017-1.663l3.94-2.57a1 1 0 0 1 1.547.837v5.26a1 1 0 0 1-1.564.826"
}, null, -1), s5 = [
  r5
];
function c5(t, l) {
  return o(), r("svg", o5, [...s5]);
}
const d5 = { render: c5 }, i5 = (t) => e(s, t, {
  default: () => [e(d5, null, null)]
}), u5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, h5 = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ n("path", { d: "m15 19 6.5-6.5L15 6M9.5 19 3 12.5 9.5 6" })
], -1), a5 = [
  h5
];
function _5(t, l) {
  return o(), r("svg", u5, [...a5]);
}
const v5 = { render: _5 }, w5 = (t) => e(s, t, {
  default: () => [e(v5, null, null)]
}), f5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, g5 = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ n("path", {
    "stroke-linecap": "round",
    d: "M16.632 7.13V5.183c0-.654-.53-1.184-1.185-1.184H5.184C4.53 4 4 4.53 4 5.184v10.263c0 .654.53 1.185 1.184 1.185h1.967"
  }),
  /* @__PURE__ */ n("path", { d: "M8.553 7.368h10.263c.654 0 1.184.53 1.184 1.185v10.263C20 19.47 19.47 20 18.816 20H8.553c-.654 0-1.185-.53-1.185-1.184V8.553c0-.654.53-1.185 1.185-1.185Z" })
], -1), $5 = [
  g5
];
function p5(t, l) {
  return o(), r("svg", f5, [...$5]);
}
const x5 = { render: p5 }, M5 = (t) => e(s, t, {
  default: () => [e(x5, null, null)]
}), k5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, C5 = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ n("path", { d: "M12 18c5.523 0 10-6 10-6s-4.477-6-10-6-10 6-10 6 4.477 6 10 6Z" }),
  /* @__PURE__ */ n("path", { d: "M12 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" })
], -1), m5 = [
  C5
];
function O5(t, l) {
  return o(), r("svg", k5, [...m5]);
}
const z5 = { render: O5 }, S5 = (t) => e(s, t, {
  default: () => [e(z5, null, null)]
}), B5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, A5 = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ n("path", { d: "M4.929 9C3.119 10.5 2 12 2 12s4.477 6 10 6a8.2 8.2 0 0 0 2-.254M10.016 6.25A8.2 8.2 0 0 1 12 6c5.523 0 10 6 10 6s-1.12 1.5-2.929 3M10.157 10.31a2.5 2.5 0 0 0 3.593 3.475M19.5 19.5l-15-15" })
], -1), H5 = [
  A5
];
function V5(t, l) {
  return o(), r("svg", B5, [...H5]);
}
const L5 = { render: V5 }, j5 = (t) => e(s, t, {
  default: () => [e(L5, null, null)]
}), F5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, q5 = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  transform: "translate(4 3)"
}, [
  /* @__PURE__ */ n("rect", {
    width: "16",
    height: "9.778",
    y: "8",
    rx: "1"
  }),
  /* @__PURE__ */ n("path", {
    "stroke-linecap": "round",
    d: "M3.556 8V4.444a4.444 4.444 0 0 1 8.888 0V8M8 11.556v2.666"
  })
], -1), y5 = [
  q5
];
function b5(t, l) {
  return o(), r("svg", F5, [...y5]);
}
const T5 = { render: b5 }, D5 = (t) => e(s, t, {
  default: () => [e(T5, null, null)]
}), Z5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, R5 = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  transform: "translate(4 3)"
}, [
  /* @__PURE__ */ n("rect", {
    width: "16",
    height: "10.353",
    y: "8.493",
    rx: "1"
  }),
  /* @__PURE__ */ n("path", {
    "stroke-linecap": "round",
    d: "M3.294 8.47V4.709C3.292 2.292 5.14.267 7.57.024s4.65 1.376 5.136 3.743M8 12.235v2.824"
  })
], -1), P5 = [
  R5
];
function I5(t, l) {
  return o(), r("svg", Z5, [...P5]);
}
const N5 = { render: I5 }, E5 = (t) => e(s, t, {
  default: () => [e(N5, null, null)]
}), U5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, W5 = /* @__PURE__ */ n("path", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M5 12h14"
}, null, -1), G5 = [
  W5
];
function J5(t, l) {
  return o(), r("svg", U5, [...G5]);
}
const Q5 = { render: J5 }, K5 = (t) => e(s, t, {
  default: () => [e(Q5, null, null)]
}), X5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Y5 = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ n("path", { d: "m12.03 5-.018 14M5 12h14" })
], -1), tt = [
  Y5
];
function et(t, l) {
  return o(), r("svg", X5, [...tt]);
}
const nt = { render: et }, lt = (t) => e(s, t, {
  default: () => [e(nt, null, null)]
}), ot = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, rt = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ n("path", {
    "stroke-linejoin": "round",
    d: "M9 3H3v6h6zM9 15H3v6h6zM21 15h-6v6h6zM21 3h-6v6h6z"
  }),
  /* @__PURE__ */ n("path", {
    "stroke-linecap": "round",
    d: "M12 3v9M12 15v6M12 12H3M21 12h-6"
  })
], -1), st = [
  rt
];
function ct(t, l) {
  return o(), r("svg", ot, [...st]);
}
const dt = { render: ct }, it = (t) => e(s, t, {
  default: () => [e(dt, null, null)]
}), ut = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, ht = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "nonzero",
  d: "M10.75 3.04a.75.75 0 0 1 1.188-.609l5.5 3.96a.75.75 0 0 1 .08 1.152L12.847 12l4.67 4.457a.75.75 0 0 1 .008 1.08l-.081.067-5.5 4.04a.75.75 0 0 1-1.194-.604V14l-4.232 4.043a.75.75 0 0 1-.978.05l-.083-.075a.75.75 0 0 1 .025-1.06L10.676 12 5.482 7.043a.75.75 0 0 1-.095-.975l.07-.086a.75.75 0 0 1 1.06-.025l4.233 4.04zm1.5 10.462v6.056l3.585-2.634zm0-8.998v5.993l3.579-3.416z"
}, null, -1), at = [
  ht
];
function _t(t, l) {
  return o(), r("svg", ut, [...at]);
}
const vt = { render: _t }, wt = (t) => e(s, t, {
  default: () => [e(vt, null, null)]
}), ft = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, gt = /* @__PURE__ */ n("g", {
  fill: "currentColor",
  "fill-rule": "evenodd"
}, [
  /* @__PURE__ */ n("path", {
    "fill-rule": "nonzero",
    d: "M12.049 6.424a5.848 5.848 0 1 1 0 11.695 5.848 5.848 0 0 1 0-11.695m0 1.5a4.348 4.348 0 1 0 0 8.695 4.348 4.348 0 0 0 0-8.695M18.44 4.632a.75.75 0 1 1 1.064 1.057l-1.14 1.147A.75.75 0 1 1 17.3 5.78zM5.514 17.485a.75.75 0 0 1 1.064 1.058l-.949.954a.75.75 0 1 1-1.064-1.058zM12.039 19.4a.75.75 0 0 1 .75.75v1.39a.75.75 0 1 1-1.5 0v-1.39a.75.75 0 0 1 .75-.75M21.307 11.058a.75.75 0 1 1 0 1.5h-1.853a.75.75 0 1 1 0-1.5zM17.78 17.294a.75.75 0 0 1 1.06 0l1.144 1.143a.75.75 0 1 1-1.06 1.06l-1.144-1.142a.75.75 0 0 1 0-1.061"
  }),
  /* @__PURE__ */ n("path", { d: "M12.049 9.027a3.244 3.244 0 1 0 0 6.488" }),
  /* @__PURE__ */ n("path", {
    "fill-rule": "nonzero",
    d: "M4.624 11.521a.75.75 0 1 1 0 1.5H2.771a.75.75 0 1 1 0-1.5zM5.041 4.63a.75.75 0 0 1 1.061 0l.951.952a.75.75 0 1 1-1.06 1.06l-.952-.951a.75.75 0 0 1 0-1.06M12.039 1.79a.75.75 0 0 1 .75.75v1.853a.75.75 0 1 1-1.5 0V2.54a.75.75 0 0 1 .75-.75"
  })
], -1), $t = [
  gt
];
function pt(t, l) {
  return o(), r("svg", ft, [...$t]);
}
const xt = { render: pt }, Mt = (t) => e(s, t, {
  default: () => [e(xt, null, null)]
}), kt = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Ct = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M14.026 2.205a6.364 6.364 0 1 0 7.768 7.768q.204.984.206 2.027c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2c.694 0 1.372.07 2.026.205Z"
}, null, -1), mt = [
  Ct
];
function Ot(t, l) {
  return o(), r("svg", kt, [...mt]);
}
const zt = { render: Ot }, St = (t) => e(s, t, {
  default: () => [e(zt, null, null)]
}), Bt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, At = /* @__PURE__ */ m('<g fill="currentColor" fill-rule="evenodd"><path fill-rule="nonzero" d="M2.933 7.445c5.65-4.535 13.833-4.218 19.122.794a.75.75 0 1 1-1.032 1.089C16.28 4.833 8.94 4.548 3.872 8.615q-.422.338-.817.713a.75.75 0 0 1-1.032-1.089q.44-.417.91-.794"></path><path fill-rule="nonzero" d="M4.859 11.5c3.965-3.966 10.395-3.966 14.36 0a.75.75 0 0 1-1.06 1.06 8.655 8.655 0 0 0-12.24 0 .75.75 0 0 1-1.06-1.06"></path><path fill-rule="nonzero" d="M7.709 14.594a6.124 6.124 0 0 1 8.66 0 .75.75 0 0 1-1.06 1.06 4.624 4.624 0 0 0-6.54 0 .75.75 0 0 1-1.06-1.06"></path><path d="M12.039 18.775a1.188 1.188 0 1 0 0-2.375 1.188 1.188 0 0 0 0 2.375"></path></g>', 1), Ht = [
  At
];
function Vt(t, l) {
  return o(), r("svg", Bt, [...Ht]);
}
const Lt = { render: Vt }, jt = (t) => e(s, t, {
  default: () => [e(Lt, null, null)]
}), Ft = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, qt = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.333 3.75c0-.092.075-.167.167-.167h9.352a.8.8 0 0 0-.019.167v16.5q0 .086.019.166H6.5a.167.167 0 0 1-.167-.166v-2.917h1.084a.75.75 0 0 0 0-1.5H6.333V12.75h1.084a.75.75 0 0 0 0-1.5H6.333V8.167h1.084a.75.75 0 1 0 0-1.5H6.333zm10.982 16.666h2.018a.167.167 0 0 0 .167-.166V3.75a.167.167 0 0 0-.167-.167h-2.018q.018.081.018.167v16.5a.8.8 0 0 1-.018.166M4.833 20.25v-2.917H3.75a.75.75 0 0 1 0-1.5h1.083V12.75H3.75a.75.75 0 0 1 0-1.5h1.083V8.167H3.75a.75.75 0 1 1 0-1.5h1.083V3.75c0-.92.746-1.667 1.667-1.667h12.833c.92 0 1.667.746 1.667 1.667v16.5c0 .92-.746 1.666-1.667 1.666H6.5c-.92 0-1.667-.746-1.667-1.666",
  "clip-rule": "evenodd"
}, null, -1), yt = [
  qt
];
function bt(t, l) {
  return o(), r("svg", Ft, [...yt]);
}
const Tt = { render: bt }, Dt = (t) => e(s, t, {
  default: () => [e(Tt, null, null)]
}), Zt = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Rt = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.417 3.75c0-.092.074-.167.166-.167h2v16.833h-2a.167.167 0 0 1-.166-.166zm3.666 16.666V3.583h9.334c.092 0 .166.075.166.167v16.5a.167.167 0 0 1-.166.166zm-.75 1.5h-2.75c-.92 0-1.666-.746-1.666-1.666V3.75c0-.92.746-1.667 1.666-1.667h12.834c.92 0 1.666.746 1.666 1.667v16.5c0 .92-.746 1.666-1.666 1.666z",
  "clip-rule": "evenodd"
}, null, -1), Pt = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.25 8.5a.75.75 0 0 1 .75-.75h3.667a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75M11.25 12.167a.75.75 0 0 1 .75-.75h3.667a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75M11.25 16a.75.75 0 0 1 .75-.75h3.667a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75",
  "clip-rule": "evenodd"
}, null, -1), It = [
  Rt,
  Pt
];
function Nt(t, l) {
  return o(), r("svg", Zt, [...It]);
}
const Et = { render: Nt }, Ut = (t) => e(s, t, {
  default: () => [e(Et, null, null)]
}), Wt = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Gt = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.25 3.608c-1.072.156-1.833 1.017-1.833 1.975v11.385q.067-.02.135-.038c.293-.116.613-.18.948-.18h12.083V3.833a.25.25 0 0 0-.25-.25H12.75V11a.75.75 0 0 1-1.219.586L10 10.36l-1.531 1.226A.75.75 0 0 1 7.25 11zM3.917 5.583v13.75A2.583 2.583 0 0 0 6.5 21.917h11.833a1.75 1.75 0 0 0 1.75-1.75V18.5q0-.128-.017-.25h.017V3.833a1.75 1.75 0 0 0-1.75-1.75H7.6c-1.988 0-3.683 1.522-3.683 3.5M6.27 18.315a3 3 0 0 0-.242.042 1.083 1.083 0 0 0 .47 2.06h11.834a.25.25 0 0 0 .25-.25V18.5a.25.25 0 0 0-.25-.25H7.477a9.5 9.5 0 0 0-1.206.065M8.75 9.44V3.75h2.5v5.69l-.781-.626a.75.75 0 0 0-.938 0z",
  "clip-rule": "evenodd"
}, null, -1), Jt = [
  Gt
];
function Qt(t, l) {
  return o(), r("svg", Wt, [...Jt]);
}
const Kt = { render: Qt }, Xt = (t) => e(s, t, {
  default: () => [e(Kt, null, null)]
}), Yt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, te = /* @__PURE__ */ n("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, [
  /* @__PURE__ */ n("path", { d: "M12.3 3.25c5.55 0 10.05 4.5 10.05 10.05 0 2.682-.9 5.258-2.524 7.018l-.222.242H4.996l-.222-.242C3.15 18.558 2.25 15.982 2.25 13.3c0-5.55 4.5-10.05 10.05-10.05m0 1.5a8.55 8.55 0 0 0-8.55 8.55c0 2.102.633 4.112 1.756 5.563l.159.197h13.269l.16-.197c1.064-1.375 1.688-3.251 1.75-5.232l.006-.331a8.55 8.55 0 0 0-8.55-8.55" }),
  /* @__PURE__ */ n("path", { d: "M12.3 12.085a2.61 2.61 0 1 1 0 5.22 2.61 2.61 0 0 1 0-5.22m0 1.5a1.11 1.11 0 1 0 0 2.22 1.11 1.11 0 0 0 0-2.22" }),
  /* @__PURE__ */ n("path", { d: "M12.3 9.295a.75.75 0 0 1 .75.75v2.79a.75.75 0 1 1-1.5 0v-2.79a.75.75 0 0 1 .75-.75M12.3 5.575a.75.75 0 0 1 .75.75v.93a.75.75 0 1 1-1.5 0v-.93a.75.75 0 0 1 .75-.75M6.255 13.015a.75.75 0 0 1 0 1.5h-.93a.75.75 0 1 1 0-1.5zM6.655 8.585a.75.75 0 0 1 1.06 0l.658.657a.75.75 0 0 1-1.06 1.06l-.658-.657a.75.75 0 0 1 0-1.06M19.275 13.015a.75.75 0 0 1 0 1.5h-.93a.75.75 0 1 1 0-1.5zM17.077 8.585a.75.75 0 1 1 1.06 1.06l-.657.658a.75.75 0 1 1-1.06-1.06z" })
], -1), ee = [
  te
];
function ne(t, l) {
  return o(), r("svg", Yt, [...ee]);
}
const le = { render: ne }, oe = (t) => e(s, t, {
  default: () => [e(le, null, null)]
}), re = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, se = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.5 8a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-1.544 5.223a6 6 0 1 0-5.912 0 7.7 7.7 0 0 0-2.981 1.84C4.586 16.54 3.75 18.612 3.75 21a.75.75 0 0 0 1.5 0c0-2.03.705-3.708 1.873-4.876C8.292 14.954 9.97 14.25 12 14.25s3.708.705 4.877 1.874C18.045 17.292 18.75 18.97 18.75 21a.75.75 0 0 0 1.5 0c0-2.388-.836-4.46-2.313-5.937a7.7 7.7 0 0 0-2.981-1.84",
  "clip-rule": "evenodd"
}, null, -1), ce = [
  se
];
function de(t, l) {
  return o(), r("svg", re, [...ce]);
}
const ie = { render: de }, ue = (t) => e(s, t, {
  default: () => [e(ie, null, null)]
}), he = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, ae = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M4 20a7.5 7.5 0 0 1 7.5-7.5c.877 0 2.5 0 4 1.5"
}, null, -1), _e = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.5 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-1.898 5.408a6 6 0 1 0-5.67-.25A8.25 8.25 0 0 0 3.25 20a.75.75 0 0 0 1.5 0 6.75 6.75 0 0 1 6.75-6.75c.843 0 2.195.006 3.47 1.28a.75.75 0 1 0 1.06-1.06 5.9 5.9 0 0 0-1.428-1.062M17.06 14.52a.5.5 0 0 1 .587.26.4.4 0 0 0 .353.232.4.4 0 0 0 .353-.232.5.5 0 0 1 .588-.26 3.47 3.47 0 0 1 1.449.843.5.5 0 0 1 .104.573.5.5 0 0 0-.044.2c0 .26.198.436.4.436h.005a.5.5 0 0 1 .486.355 3.74 3.74 0 0 1 .089 1.806.5.5 0 0 1-.542.401l-.038-.002c-.202 0-.4.177-.4.437 0 .113.039.213.1.288a.5.5 0 0 1-.021.655 3.5 3.5 0 0 1-1.524.966.5.5 0 0 1-.625-.331.405.405 0 0 0-.38-.298.405.405 0 0 0-.38.298.5.5 0 0 1-.625.33 3.5 3.5 0 0 1-1.524-.965.5.5 0 0 1-.021-.655.46.46 0 0 0 .1-.288c0-.26-.198-.436-.4-.436q-.02 0-.038.002a.5.5 0 0 1-.542-.402 3.75 3.75 0 0 1 .089-1.806.5.5 0 0 1 .486-.355h.005c.202 0 .4-.177.4-.436a.5.5 0 0 0-.044-.2.5.5 0 0 1 .104-.573c.403-.39.898-.685 1.45-.843m-.53 1.369q.02.12.02.247c0 .64-.415 1.202-1.006 1.379a2.8 2.8 0 0 0-.039.664 1.43 1.43 0 0 1 1.045 1.39q0 .267-.09.505.214.174.46.299a1.38 1.38 0 0 1 1.08-.524c.441 0 .827.207 1.08.524q.246-.124.46-.3a1.5 1.5 0 0 1-.09-.504c0-.654.434-1.227 1.045-1.39a2.8 2.8 0 0 0-.04-.664 1.435 1.435 0 0 1-.984-1.626 2.5 2.5 0 0 0-.488-.291 1.376 1.376 0 0 1-1.966 0 2.5 2.5 0 0 0-.488.29",
  "clip-rule": "evenodd"
}, null, -1), ve = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.5 18a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m1.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1",
  "clip-rule": "evenodd"
}, null, -1), we = [
  ae,
  _e,
  ve
];
function fe(t, l) {
  return o(), r("svg", he, [...we]);
}
const ge = { render: fe }, $e = (t) => e(s, t, {
  default: () => [e(ge, null, null)]
}), pe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, xe = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M4 20a7.5 7.5 0 0 1 7.5-7.5c.877 0 2.5 0 4 1.5"
}, null, -1), Me = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.5 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-1.898 5.408a6 6 0 1 0-5.67-.25A8.25 8.25 0 0 0 3.25 20a.75.75 0 0 0 1.5 0 6.75 6.75 0 0 1 6.75-6.75c.843 0 2.195.006 3.47 1.28a.75.75 0 1 0 1.06-1.06 5.9 5.9 0 0 0-1.428-1.062M17.5 15.833a1.333 1.333 0 1 1 .481 1.026l-1.501.91a1.3 1.3 0 0 1 .005.43l1.538.908a1.333 1.333 0 1 1-.509.86l-1.537-.908a1.333 1.333 0 1 1-.028-2.139l1.559-.943a1 1 0 0 1-.008-.144m1.333-.333a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667m-3.666 2.167a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667m3.333 2.5a.333.333 0 1 1 .667 0 .333.333 0 0 1-.667 0",
  "clip-rule": "evenodd"
}, null, -1), ke = [
  xe,
  Me
];
function Ce(t, l) {
  return o(), r("svg", pe, [...ke]);
}
const me = { render: Ce }, Oe = (t) => e(s, t, {
  default: () => [e(me, null, null)]
}), ze = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Se = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M9.883 20.113c-.335.44-.887.76-1.393.536a9 9 0 0 1-2.358-1.525c-.37-.331-.365-.89-.183-1.353a2.9 2.9 0 0 0 .201-1.065c0-1.551-1.209-2.809-2.7-2.809-.152 0-.29-.1-.315-.25A9.8 9.8 0 0 1 3.4 9.253a.05.05 0 0 1 .049-.036c1.491 0 2.7-1.258 2.7-2.81q0-.288-.054-.56c-.082-.42-.019-.885.312-1.158A8.9 8.9 0 0 1 8.8 3.271c.451-.179.936.063 1.268.416.49.523 1.175.847 1.932.847s1.442-.324 1.932-.847c.332-.353.817-.595 1.268-.416.87.344 1.676.825 2.392 1.417.33.273.394.737.312 1.158a3 3 0 0 0-.054.56c0 1.552 1.209 2.81 2.7 2.81a.05.05 0 0 1 .049.036 9.796 9.796 0 0 1 .267 4.396c-.026.15-.164.25-.316.25-1.491 0-2.7 1.257-2.7 2.808 0 .377.071.737.2 1.065.183.463.189 1.021-.182 1.353a9 9 0 0 1-2.357 1.525c-.507.223-1.059-.096-1.394-.536A2.66 2.66 0 0 0 12 19.047c-.858 0-1.623.417-2.117 1.066Z"
}, null, -1), Be = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
}, null, -1), Ae = [
  Se,
  Be
];
function He(t, l) {
  return o(), r("svg", ze, [...Ae]);
}
const Ve = { render: He }, Le = (t) => e(s, t, {
  default: () => [e(Ve, null, null)]
}), je = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Fe = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M9.428 20a8.95 8.95 0 0 1-3.913-2.483c.396-.49.635-1.12.635-1.81 0-1.552-1.209-2.81-2.7-2.81q-.136 0-.267.014a9.8 9.8 0 0 1 .23-4.695h.037c1.491 0 2.7-1.258 2.7-2.81 0-.445-.1-.866-.277-1.24A8.9 8.9 0 0 1 9.593 2c.447.91 1.357 1.534 2.407 1.534S13.96 2.911 14.407 2a8.9 8.9 0 0 1 3.72 2.166 2.9 2.9 0 0 0-.277 1.24c0 1.552 1.209 2.81 2.7 2.81h.038a9.77 9.77 0 0 1 .23 4.695 3 3 0 0 0-.268-.014c-1.491 0-2.7 1.258-2.7 2.81 0 .69.239 1.32.635 1.81C17.423 18.666 16.508 19.533 15 20c-1-1-1.796-1.953-3-1.953s-2.224.82-2.572 1.953Z"
}, null, -1), qe = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M12 14.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
}, null, -1), ye = /* @__PURE__ */ n("circle", {
  cx: "16",
  cy: "16",
  r: "6",
  fill: "#fff"
}, null, -1), be = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M16 20.375a4.375 4.375 0 1 0 0-8.75 4.375 4.375 0 0 0 0 8.75m-2.187-4.246.441-.442 1.121 1.121 2.37-2.37.442.442-2.812 2.812z"
}, null, -1), Te = [
  Fe,
  qe,
  ye,
  be
];
function De(t, l) {
  return o(), r("svg", je, [...Te]);
}
const Ze = { render: De }, Re = (t) => e(s, t, {
  default: () => [e(Ze, null, null)]
}), Pe = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Ie = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.833 4.833a.75.75 0 0 0-.75.75v12.833c0 .415.336.75.75.75H17.5a.75.75 0 0 0 .75-.75v-3.312l2.433 2.053a.75.75 0 0 0 1.234-.573V7.417a.75.75 0 0 0-1.234-.573L18.25 8.897V5.583a.75.75 0 0 0-.75-.75zm.75 12.833V6.333H16.75v11.333zm14.667-4.525V10.86l2.167-1.828v5.939z",
  "clip-rule": "evenodd"
}, null, -1), Ne = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.216 9.228a.75.75 0 0 1 1.056-.096l2.75 2.292a.75.75 0 0 1 0 1.152l-2.75 2.291a.75.75 0 1 1-.96-1.152L10.37 12l-2.058-1.716a.75.75 0 0 1-.096-1.056",
  "clip-rule": "evenodd"
}, null, -1), Ee = [
  Ie,
  Ne
];
function Ue(t, l) {
  return o(), r("svg", Pe, [...Ee]);
}
const We = { render: Ue }, Ge = (t) => e(s, t, {
  default: () => [e(We, null, null)]
}), Je = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Qe = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.496 8.094c-.69.77-1.029 1.751-1.275 2.612l-.155.544H6.5c-.38 0-1.363.158-2.227.698-.824.515-1.523 1.357-1.523 2.802 0 1.211.548 1.92 1.267 2.36.762.468 1.738.64 2.483.64h11c.893 0 1.851-.226 2.564-.735.678-.485 1.186-1.258 1.186-2.515 0-1.795-.922-2.764-1.878-3.32a5.7 5.7 0 0 0-1.927-.68l-.026-.004h-.004l-.498-.056-.138-.484c-.218-.761-.647-1.555-1.38-2.158-.725-.595-1.8-1.048-3.399-1.048-1.803 0-2.844.608-3.504 1.344m9.577.997a5.7 5.7 0 0 0-1.722-2.452C15.326 5.797 13.901 5.25 12 5.25c-2.197 0-3.656.767-4.62 1.843-.772.86-1.187 1.874-1.451 2.702a6.4 6.4 0 0 0-2.452.882c-1.176.735-2.227 2.018-2.227 4.073 0 1.788.869 2.956 1.983 3.64 1.071.657 2.346.86 3.267.86h11c1.107 0 2.399-.274 3.436-1.015 1.072-.765 1.814-1.992 1.814-3.735 0-2.455-1.328-3.861-2.622-4.617a7.1 7.1 0 0 0-2.055-.792",
  "clip-rule": "evenodd"
}, null, -1), Ke = [
  Qe
];
function Xe(t, l) {
  return o(), r("svg", Je, [...Ke]);
}
const Ye = { render: Xe }, tn = (t) => e(s, t, {
  default: () => [e(Ye, null, null)]
}), en = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, nn = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.167 9.417a.75.75 0 0 1 .75.75v5.958a.75.75 0 0 1-1.5 0v-5.958a.75.75 0 0 1 .75-.75M13.833 9.417a.75.75 0 0 1 .75.75v5.958a.75.75 0 0 1-1.5 0v-5.958a.75.75 0 0 1 .75-.75",
  "clip-rule": "evenodd"
}, null, -1), ln = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.84 2.083a.75.75 0 0 0-.657.39L7.89 4.832H2.833a.75.75 0 1 0 0 1.5h1.542v14.833c0 .415.336.75.75.75h13.75a.75.75 0 0 0 .75-.75V6.333h1.542a.75.75 0 1 0 0-1.5h-5.052L14.85 2.478a.75.75 0 0 0-.66-.395zm4.572 2.75-.671-1.25h-3.456L9.6 4.833zm-6.079 1.5H5.875v14.083h12.25V6.333H8.333",
  "clip-rule": "evenodd"
}, null, -1), on = [
  nn,
  ln
];
function rn(t, l) {
  return o(), r("svg", en, [...on]);
}
const sn = { render: rn }, cn = (t) => e(s, t, {
  default: () => [e(sn, null, null)]
}), dn = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, un = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3 3.25A1.75 1.75 0 0 0 1.25 5v13.818c0 .944.67 1.932 1.75 1.932h18c1.08 0 1.75-.988 1.75-1.932V5A1.75 1.75 0 0 0 21 3.25zm18.25 3.286V5a.25.25 0 0 0-.25-.25H3a.25.25 0 0 0-.25.25v1.536l8.691 4.346a1.25 1.25 0 0 0 1.118 0zM2.75 8.213v10.605c0 .157.054.279.115.351.06.07.11.08.135.08h18c.024 0 .075-.01.135-.08a.55.55 0 0 0 .115-.351V8.213l-8.02 4.01a2.75 2.75 0 0 1-2.46 0z",
  "clip-rule": "evenodd"
}, null, -1), hn = [
  un
];
function an(t, l) {
  return o(), r("svg", dn, [...hn]);
}
const _n = { render: an }, vn = (t) => e(s, t, {
  default: () => [e(_n, null, null)]
}), wn = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, fn = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.333 4.157A.75.75 0 0 1 4 3.75h16a.75.75 0 0 1 .613 1.183l-5.863 8.305V21a.75.75 0 0 1-1.055.685l-4-1.777a.75.75 0 0 1-.445-.686V13.15L3.39 4.936a.75.75 0 0 1-.057-.78M5.457 5.25l5.154 7.223c.09.127.139.28.139.436v5.826l2.5 1.11V13a.75.75 0 0 1 .137-.432l5.166-7.318z",
  "clip-rule": "evenodd"
}, null, -1), gn = [
  fn
];
function $n(t, l) {
  return o(), r("svg", wn, [...gn]);
}
const pn = { render: $n }, xn = (t) => e(s, t, {
  default: () => [e(pn, null, null)]
}), Mn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, kn = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, [
  /* @__PURE__ */ n("path", { d: "M11.5 20a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z" }),
  /* @__PURE__ */ n("path", {
    "stroke-linecap": "round",
    d: "M14.329 8.172A3.99 3.99 0 0 0 11.5 7a3.99 3.99 0 0 0-2.828 1.172M17.611 17.611l4.242 4.243"
  })
], -1), Cn = [
  kn
];
function mn(t, l) {
  return o(), r("svg", Mn, [...Cn]);
}
const On = { render: mn }, zn = (t) => e(s, t, {
  default: () => [e(On, null, null)]
}), Sn = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Bn = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.25 4a.25.25 0 0 1 .25-.25h5.649l2.5 3H20.5a.25.25 0 0 1 .25.25v3.25H3.25zm0 7.75V20c0 .138.112.25.25.25h17a.25.25 0 0 0 .25-.25v-8.25zm.25-9.5A1.75 1.75 0 0 0 1.75 4v16c0 .966.784 1.75 1.75 1.75h17A1.75 1.75 0 0 0 22.25 20V7a1.75 1.75 0 0 0-1.75-1.75h-8.149l-2.5-3z",
  "clip-rule": "evenodd"
}, null, -1), An = [
  Bn
];
function Hn(t, l) {
  return o(), r("svg", Sn, [...An]);
}
const Vn = { render: Hn }, Ln = (t) => e(s, t, {
  default: () => [e(Vn, null, null)]
}), jn = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Fn = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3 2.75A1.75 1.75 0 0 0 1.25 4.5v16a.75.75 0 0 0 .75.75h18a.75.75 0 0 0 .735-.603l2-10A.75.75 0 0 0 22 9.75h-1.5V7.5a1.75 1.75 0 0 0-1.75-1.75h-6.399l-2.5-3zm16 7V7.5a.25.25 0 0 0-.25-.25h-7.101l-2.5-3H3a.25.25 0 0 0-.25.25v9.677l.927-3.852a.75.75 0 0 1 .73-.575H19m-16.04 10h16.425l1.7-8.5H5.086z",
  "clip-rule": "evenodd"
}, null, -1), qn = [
  Fn
];
function yn(t, l) {
  return o(), r("svg", jn, [...qn]);
}
const bn = { render: yn }, Tn = (t) => e(s, t, {
  default: () => [e(bn, null, null)]
}), Dn = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Zn = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.399 4.399A10.72 10.72 0 0 1 12 1.25c2.968 0 5.657 1.204 7.601 3.149l-.53.53.53-.53A10.72 10.72 0 0 1 22.75 12c0 2.968-1.204 5.657-3.149 7.601A10.72 10.72 0 0 1 12 22.75a10.72 10.72 0 0 1-7.601-3.149l.53-.53-.53.53A10.72 10.72 0 0 1 1.25 12c0-2.968 1.204-5.657 3.149-7.601M12 2.75a9.22 9.22 0 0 0-6.54 2.71A9.22 9.22 0 0 0 2.75 12a9.22 9.22 0 0 0 2.71 6.54A9.22 9.22 0 0 0 12 21.25a9.22 9.22 0 0 0 6.54-2.71A9.22 9.22 0 0 0 21.25 12a9.22 9.22 0 0 0-2.71-6.54A9.22 9.22 0 0 0 12 2.75",
  "clip-rule": "evenodd"
}, null, -1), Rn = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.25 9.313a3.75 3.75 0 1 1 4.977 3.544.9.9 0 0 0-.375.237c-.081.09-.102.163-.102.219v1a.75.75 0 0 1-1.5 0v-1c0-1.003.808-1.639 1.486-1.874A2.251 2.251 0 1 0 9.75 9.313a.75.75 0 0 1-1.5 0M12 19.313a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
  "clip-rule": "evenodd"
}, null, -1), Pn = [
  Zn,
  Rn
];
function In(t, l) {
  return o(), r("svg", Dn, [...Pn]);
}
const Nn = { render: In }, En = (t) => e(s, t, {
  default: () => [e(Nn, null, null)]
}), Un = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Wn = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "m20.495 14.256.53.53.002-.002zm-6.23 6.23-.53-.53h-.001zm-2.46 0 .531-.53zM4 12.689h-.75V13l.22.22zM4 4v-.75a.75.75 0 0 0-.75.75zm8.69 0 .53-.53-.22-.22h-.31zm7.805 7.805.532-.528-.002-.002zm-.53 1.92-6.23 6.23 1.06 1.061 6.23-6.23zm-6.231 6.23a.99.99 0 0 1-.7.29v1.5c.661 0 1.294-.262 1.761-.729zm-.7.29a1 1 0 0 1-.698-.29l-1.061 1.061c.466.467 1.1.73 1.76.73zm-.699-.29L4.53 12.16l-1.06 1.06 7.805 7.798zM4.75 12.69V4h-1.5v8.69zM4 4.75h8.69v-1.5H4zm8.159-.22 7.805 7.806 1.061-1.06L13.22 3.47zm7.804 7.804a.99.99 0 0 1 0 1.393l1.063 1.057a2.49 2.49 0 0 0 0-3.507z"
}, null, -1), Gn = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M11.25 9.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"
}, null, -1), Jn = [
  Wn,
  Gn
];
function Qn(t, l) {
  return o(), r("svg", Un, [...Jn]);
}
const Kn = { render: Qn }, Xn = (t) => e(s, t, {
  default: () => [e(Kn, null, null)]
}), Yn = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, t2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.219 3.41c-1.583-1.584-4.156-1.529-5.747.062-1.59 1.59-1.646 4.164-.063 5.747l3.807 3.807a.75.75 0 1 0 1.06-1.061L4.47 8.158c-.97-.97-.97-2.593.063-3.625s2.655-1.034 3.625-.063l4.382 4.382.003.003c.97.97.969 2.593-.063 3.625a.75.75 0 0 0 1.06 1.06c1.59-1.589 1.646-4.16.067-5.743l-.004-.003z",
  "clip-rule": "evenodd"
}, null, -1), e2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.731 20.541c1.583 1.583 4.156 1.528 5.747-.063 1.59-1.59 1.646-4.164.063-5.747l-3.807-3.806a.75.75 0 1 0-1.06 1.06l3.806 3.807c.97.97.97 2.594-.063 3.626s-2.655 1.033-3.625.062l-4.382-4.382-.003-.002c-.97-.97-.969-2.594.063-3.626a.75.75 0 0 0-1.06-1.06c-1.59 1.59-1.646 4.16-.066 5.743l.003.003z",
  "clip-rule": "evenodd"
}, null, -1), n2 = [
  t2,
  e2
];
function l2(t, l) {
  return o(), r("svg", Yn, [...n2]);
}
const o2 = { render: l2 }, r2 = (t) => e(s, t, {
  default: () => [e(o2, null, null)]
}), s2 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, c2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15.428 10.505a.75.75 0 0 1 1.06 0l3.89 3.889c1.675 1.676 1.961 4.37.094 6.152-1.825 1.74-4.426 1.581-6.127-.12l-3.89-3.889a.75.75 0 1 1 1.062-1.06l3.889 3.889c1.163 1.163 2.833 1.236 4.03.094 1.154-1.1 1.069-2.818-.12-4.005l-3.888-3.89a.75.75 0 0 1 0-1.06M13.5 8.544a.75.75 0 0 0 0-1.06l-3.89-3.89C7.936 1.918 5.242 1.632 3.46 3.5c-1.742 1.825-1.582 4.426.118 6.127l3.89 3.889a.75.75 0 0 0 1.06-1.06L4.64 8.565c-1.163-1.163-1.236-2.834-.094-4.03 1.1-1.154 2.817-1.069 4.005.119l3.89 3.889a.75.75 0 0 0 1.06 0",
  "clip-rule": "evenodd"
}, null, -1), d2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.144 8.063a.75.75 0 0 1 1.061 0l1.944 1.945a.75.75 0 1 1-1.06 1.06L8.144 9.125a.75.75 0 0 1 0-1.06M12.682 12.6a.75.75 0 0 1 1.06 0l1.945 1.945a.75.75 0 1 1-1.06 1.06l-1.945-1.944a.75.75 0 0 1 0-1.06",
  "clip-rule": "evenodd"
}, null, -1), i2 = [
  c2,
  d2
];
function u2(t, l) {
  return o(), r("svg", s2, [...i2]);
}
const h2 = { render: u2 }, a2 = (t) => e(s, t, {
  default: () => [e(h2, null, null)]
}), _2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, v2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13.25 3a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0V3.75H14a.75.75 0 0 1-.75-.75M4.5 3.75a.75.75 0 0 0-.75.75v15c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-4.763a.75.75 0 0 1 1.5 0V19.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25v-15A2.25 2.25 0 0 1 4.5 2.25H9a.75.75 0 0 1 0 1.5z",
  "clip-rule": "evenodd"
}, null, -1), w2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M21.08 2.92a.75.75 0 0 1 0 1.06l-7.65 7.65a.75.75 0 1 1-1.06-1.06l7.65-7.65a.75.75 0 0 1 1.06 0",
  "clip-rule": "evenodd"
}, null, -1), f2 = [
  v2,
  w2
];
function g2(t, l) {
  return o(), r("svg", _2, [...f2]);
}
const $2 = { render: g2 }, p2 = (t) => e(s, t, {
  default: () => [e($2, null, null)]
}), x2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, M2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.25 5.5a3.25 3.25 0 1 1 .799 2.134L9.577 10.95a3.25 3.25 0 0 1 .028 2.014l5.554 3.282a3.25 3.25 0 1 1-.764 1.291l-5.554-3.282a3.25 3.25 0 1 1-.064-4.574l5.573-3.377a3.3 3.3 0 0 1-.1-.804m3.25-1.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m-11 6.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m9.25 8.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0",
  "clip-rule": "evenodd"
}, null, -1), k2 = [
  M2
];
function C2(t, l) {
  return o(), r("svg", x2, [...k2]);
}
const m2 = { render: C2 }, O2 = (t) => e(s, t, {
  default: () => [e(m2, null, null)]
}), z2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, S2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
  "clip-rule": "evenodd"
}, null, -1), B2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.194 18.4c.78-1.56 1.306-3.821 1.306-6.4s-.526-4.84-1.306-6.4C13.369 3.95 12.507 3.5 12 3.5s-1.369.45-2.194 2.1C9.026 7.16 8.5 9.42 8.5 12s.526 4.84 1.306 6.4c.825 1.65 1.688 2.1 2.194 2.1.507 0 1.369-.45 2.194-2.1M12 22c2.761 0 5-4.477 5-10S14.761 2 12 2 7 6.477 7 12s2.239 10 5 10",
  "clip-rule": "evenodd"
}, null, -1), A2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M22.5 12.75H2v-1.5h20.5z",
  "clip-rule": "evenodd"
}, null, -1), H2 = [
  S2,
  B2,
  A2
];
function V2(t, l) {
  return o(), r("svg", z2, [...H2]);
}
const L2 = { render: V2 }, j2 = (t) => e(s, t, {
  default: () => [e(L2, null, null)]
}), F2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, q2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.75 9.5a8.25 8.25 0 1 1 16.5 0c0 2.093-.713 4.1-1.675 5.86-1.145 2.094-2.673 3.898-3.902 5.171a30 30 0 0 1-1.559 1.501 22 22 0 0 1-.596.514l-.035.028-.01.008-.004.003L12 22l-.469.585-.004-.003-.01-.008-.035-.028-.129-.108a29.453 29.453 0 0 1-2.025-1.907c-1.23-1.273-2.758-3.077-3.903-5.171C4.463 13.6 3.75 11.593 3.75 9.5M12 22l-.469.585c.274.22.664.22.938 0zm0-.985.116-.102c.37-.331.89-.816 1.478-1.424 1.178-1.22 2.608-2.916 3.664-4.849.89-1.628 1.492-3.383 1.492-5.14a6.75 6.75 0 0 0-13.5 0c0 1.757.602 3.512 1.492 5.14 1.056 1.933 2.486 3.629 3.664 4.85A28 28 0 0 0 12 21.015",
  "clip-rule": "evenodd"
}, null, -1), y2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.25 9.5a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M12 7.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5",
  "clip-rule": "evenodd"
}, null, -1), b2 = [
  q2,
  y2
];
function T2(t, l) {
  return o(), r("svg", F2, [...b2]);
}
const D2 = { render: T2 }, Z2 = (t) => e(s, t, {
  default: () => [e(D2, null, null)]
}), R2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, P2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M21.75 4A1.75 1.75 0 0 0 20 2.25h-9.994A1.75 1.75 0 0 0 8.256 4v2a.75.75 0 0 0 1.5 0V4a.25.25 0 0 1 .25-.25H20a.25.25 0 0 1 .25.25v16a.25.25 0 0 1-.25.25H10a.25.25 0 0 1-.25-.25v-2a.75.75 0 0 0-1.5 0v2c0 .966.784 1.75 1.75 1.75h10A1.75 1.75 0 0 0 21.75 20z",
  "clip-rule": "evenodd"
}, null, -1), I2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.47 7.47a.75.75 0 0 0 0 1.06L14.94 12l-3.47 3.47a.75.75 0 1 0 1.06 1.06l4-4a.75.75 0 0 0 0-1.06l-4-4a.75.75 0 0 0-1.06 0",
  "clip-rule": "evenodd"
}, null, -1), N2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.25 11.996a.75.75 0 0 0-.75-.75H4a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 .75-.75",
  "clip-rule": "evenodd"
}, null, -1), E2 = [
  P2,
  I2,
  N2
];
function U2(t, l) {
  return o(), r("svg", R2, [...E2]);
}
const W2 = { render: U2 }, G2 = (t) => e(s, t, {
  default: () => [e(W2, null, null)]
}), J2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Q2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.25 4c0-.966.784-1.75 1.75-1.75h9.995c.966 0 1.75.784 1.75 1.75v2a.75.75 0 0 1-1.5 0V4a.25.25 0 0 0-.25-.25H4a.25.25 0 0 0-.25.25v16c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25v-2a.75.75 0 0 1 1.5 0v2A1.75 1.75 0 0 1 14 21.75H4A1.75 1.75 0 0 1 2.25 20zM16.94 8l4 4-3.47 3.47a.75.75 0 1 0 1.06 1.06l4-4a.75.75 0 0 0 0-1.06L18 6.94z",
  "clip-rule": "evenodd"
}, null, -1), K2 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M22.25 11.996a.75.75 0 0 0-.75-.75H10a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 .75-.75",
  "clip-rule": "evenodd"
}, null, -1), X2 = [
  Q2,
  K2
];
function Y2(t, l) {
  return o(), r("svg", J2, [...X2]);
}
const tl = { render: Y2 }, el = (t) => e(s, t, {
  default: () => [e(tl, null, null)]
}), nl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, ll = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.326 7.306A10.75 10.75 0 0 1 12 1.25c5.937 0 10.75 4.813 10.75 10.75S17.937 22.75 12 22.75 1.25 17.937 1.25 12c0-1.683.387-3.276 1.076-4.694m.875 1.832A9.2 9.2 0 0 0 2.75 12a9.25 9.25 0 0 0 5.588 8.497l3.5-3.25a5.24 5.24 0 0 1-3.874-1.89.8.8 0 0 1-.123-.127zm3.586 2.233L3.884 7.56A9.25 9.25 0 0 1 12 2.75a9.24 9.24 0 0 1 7.617 4H12a5.25 5.25 0 0 0-5.213 4.621M12 8.25a3.75 3.75 0 1 0 2.294 6.717l.018-.017a1 1 0 0 1 .098-.077A3.75 3.75 0 0 0 12 8.25m3.27 7.858A5.24 5.24 0 0 0 17.25 12a5.23 5.23 0 0 0-1.576-3.75h4.784A9.25 9.25 0 0 1 9.972 21.027z",
  "clip-rule": "evenodd"
}, null, -1), ol = [
  ll
];
function rl(t, l) {
  return o(), r("svg", nl, [...ol]);
}
const sl = { render: rl }, cl = (t) => e(s, t, {
  default: () => [e(sl, null, null)]
}), dl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, il = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.632 2.346a.75.75 0 0 1 .736 0l8 4.5a.75.75 0 0 1 .382.654v9a.75.75 0 0 1-.382.654l-8 4.5a.75.75 0 0 1-.736 0l-8-4.5a.75.75 0 0 1-.382-.654v-9a.75.75 0 0 1 .382-.654zm7.618 6.375v3.136l-3.611 1.986a.75.75 0 0 0-.389.657v3.811l-2.5 1.407v-7.283zm-8 3.714-6.5-3.714v2.872a.8.8 0 0 1 .15.072l3.5 2.2a.75.75 0 0 1 .35.635v3.811l2.5 1.407zm7.166-4.965L12 11.136 5.584 7.47l2.453-1.38a1 1 0 0 0 .09.061l3.5 2a.75.75 0 0 0 .745 0l3.5-2a1 1 0 0 0 .091-.061zM12 6.636 9.552 5.237 12 3.861l2.448 1.376zm7.25 9.425-2.5 1.407v-2.525l2.5-1.375zm-12-1.147v2.554l-2.5-1.407v-2.718z",
  "clip-rule": "evenodd"
}, null, -1), ul = [
  il
];
function hl(t, l) {
  return o(), r("svg", dl, [...ul]);
}
const al = { render: hl }, _l = (t) => e(s, t, {
  default: () => [e(al, null, null)]
}), vl = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, wl = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M19.456 5.956c.81 1.014 1.294 2.227 1.294 3.544 0 1.874-.837 3.781-2.488 5.02-.696.521-1.519.91-2.405 1.187.246.486.389.979.389 1.472v4.326a.75.75 0 0 1-1.5 0V17.18c0-.337-.166-.822-.664-1.478a.75.75 0 0 1 .438-1.197c1.128-.235 2.107-.633 2.842-1.185 1.245-.933 1.888-2.38 1.888-3.82 0-.963-.364-1.883-1.03-2.687a1.1 1.1 0 0 1-.21-.424 2 2 0 0 1-.051-.344c-.012-.209.001-.443.022-.666.026-.283.073-.62.117-.942.024-.171.047-.338.066-.49q.03-.244.047-.436l-.246.134-.048.026c-.304.166-.634.347-.96.507-.34.166-.706.325-1.06.422-.342.094-.764.158-1.174.037A9.6 9.6 0 0 0 12 4.25c-.839 0-1.642.104-2.389.294-.872.222-1.663-.101-2.267-.422a16 16 0 0 1-.707-.408l-.174-.105q-.2-.12-.38-.218a7 7 0 0 0-.055.75c-.009.288-.009.554-.008.82 0 .197 0 .393-.003.598a6 6 0 0 1-.034.62 2 2 0 0 1-.056.3 1.1 1.1 0 0 1-.192.39c-.638.79-.985 1.689-.985 2.63 0 1.395.762 2.86 2.043 3.82.847.635 1.936 1.06 3.201 1.272a.75.75 0 0 1 .426 1.25c-.511.564-.669.995-.669 1.306v4.358a.75.75 0 0 1-1.5 0v-4.358c0-.461.129-.905.352-1.33-1-.28-1.92-.706-2.71-1.298C4.28 13.31 3.25 11.42 3.25 9.5c0-1.286.463-2.475 1.24-3.475l.003-.022a5 5 0 0 0 .024-.468c.002-.142.002-.322.002-.517 0-.299 0-.633.01-.921.014-.486.052-1.053.2-1.482.072-.21.21-.511.503-.71.352-.239.747-.215 1.064-.079.331.143.65.325.935.495l.2.12c.217.13.415.25.618.358.534.284.89.369 1.192.292.869-.221 1.797-.34 2.759-.34 1.108 0 2.17.158 3.15.448.014.004.113.02.348-.045a5 5 0 0 0 .8-.324c.294-.144.597-.31.909-.48l.038-.021c.316-.173.646-.353.948-.493.26-.121.698-.22 1.088.082.313.242.393.605.421.79.064.415.008.965-.05 1.425q-.037.294-.075.563c-.04.295-.079.568-.103.823a3 3 0 0 0-.018.438",
  "clip-rule": "evenodd"
}, null, -1), fl = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.424 15.541c-.497-.591-1.13-.808-1.643-.65a.75.75 0 0 0 .128 1.461c.188.023.303.083.385.176q.034.042.07.099c.169.277.582.956 1.144 1.573.536.587 1.375 1.309 2.405 1.309H9a.75.75 0 0 0 0-1.5H6.913c-.346 0-.8-.276-1.296-.82-.462-.506-.814-1.083-.976-1.35m0 0a2 2 0 0 0-.217-.298Z",
  "clip-rule": "evenodd"
}, null, -1), gl = [
  wl,
  fl
];
function $l(t, l) {
  return o(), r("svg", vl, [...gl]);
}
const pl = { render: $l }, xl = (t) => e(s, t, {
  default: () => [e(pl, null, null)]
}), Ml = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, kl = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M8 3H4a1 1 0 0 0-1 1v4M16 3h4a1 1 0 0 1 1 1v4M8 21H4a1 1 0 0 1-1-1v-4.5M16 21h4a1 1 0 0 0 1-1v-4"
}, null, -1), Cl = [
  kl
];
function ml(t, l) {
  return o(), r("svg", Ml, [...Cl]);
}
const Ol = { render: ml }, zl = (t) => e(s, t, {
  default: () => [e(Ol, null, null)]
}), Sl = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Bl = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M13 12H3M21 5.5H3M17 18.5H3"
}, null, -1), Al = [
  Bl
];
function Hl(t, l) {
  return o(), r("svg", Sl, [...Al]);
}
const Vl = { render: Hl }, Ll = (t) => e(s, t, {
  default: () => [e(Vl, null, null)]
}), jl = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Fl = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M17 12H7M21 5.5H3M19 18.5H5"
}, null, -1), ql = [
  Fl
];
function yl(t, l) {
  return o(), r("svg", jl, [...ql]);
}
const bl = { render: yl }, Tl = (t) => e(s, t, {
  default: () => [e(bl, null, null)]
}), Dl = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Zl = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M21 12H11M21 5.5H3M21 18.5H7"
}, null, -1), Rl = [
  Zl
];
function Pl(t, l) {
  return o(), r("svg", Dl, [...Rl]);
}
const Il = { render: Pl }, Nl = (t) => e(s, t, {
  default: () => [e(Il, null, null)]
}), El = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Ul = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M21 12H3M21 5.5H3M21 18.5H3"
}, null, -1), Wl = [
  Ul
];
function Gl(t, l) {
  return o(), r("svg", El, [...Wl]);
}
const Jl = { render: Gl }, Ql = (t) => e(s, t, {
  default: () => [e(Jl, null, null)]
}), Kl = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Xl = /* @__PURE__ */ n("path", {
  stroke: "#333",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M20.5 4h-17a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h17a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Z"
}, null, -1), Yl = /* @__PURE__ */ n("path", {
  stroke: "#333",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M2 20h20M11 7h2"
}, null, -1), to = [
  Xl,
  Yl
];
function eo(t, l) {
  return o(), r("svg", Kl, [...to]);
}
const no = { render: eo }, lo = (t) => e(s, t, {
  default: () => [e(no, null, null)]
}), oo = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, ro = /* @__PURE__ */ n("path", {
  stroke: "#333",
  "stroke-width": "1.5",
  d: "M17 2H7a1.5 1.5 0 0 0-1.5 1.5v17A1.5 1.5 0 0 0 7 22h10a1.5 1.5 0 0 0 1.5-1.5v-17A1.5 1.5 0 0 0 17 2Z"
}, null, -1), so = /* @__PURE__ */ n("path", {
  stroke: "#333",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M11 5h2M10 19h4"
}, null, -1), co = [
  ro,
  so
];
function io(t, l) {
  return o(), r("svg", oo, [...co]);
}
const uo = { render: io }, ho = (t) => e(s, t, {
  default: () => [e(uo, null, null)]
}), ao = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, _o = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "square",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M8.5 5.5 12 2l3.5 3.5L12 9zM15 12.5 18.5 9l3.5 3.5-3.5 3.5zM8.5 18.5 12 15l3.5 3.5L12 22zM2 12l3.5-3.5L9 12l-3.5 3.5z"
}, null, -1), vo = [
  _o
];
function wo(t, l) {
  return o(), r("svg", ao, [...vo]);
}
const fo = { render: wo }, go = (t) => e(s, t, {
  default: () => [e(fo, null, null)]
}), $o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, po = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M15.5 3h-7v4.5h7zM10 16.5H3V21h7zM21 16.5h-7V21h7zM12 8v4M6.5 16.5V12h11v4.5"
}, null, -1), xo = [
  po
];
function Mo(t, l) {
  return o(), r("svg", $o, [...xo]);
}
const ko = { render: Mo }, Co = (t) => e(s, t, {
  default: () => [e(ko, null, null)]
}), mo = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Oo = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M8 3.024h8M8 21h8"
}, null, -1), zo = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M12 3.5V21"
}, null, -1), So = [
  Oo,
  zo
];
function Bo(t, l) {
  return o(), r("svg", mo, [...So]);
}
const Ao = { render: Bo }, Ho = (t) => e(s, t, {
  default: () => [e(Ao, null, null)]
}), Vo = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Lo = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M10 3.024h8M6 21h8"
}, null, -1), jo = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M8.777 20.823a.75.75 0 1 0 1.446.401zm5-18.023-5 18.023 1.446.401 5-18.024z"
}, null, -1), Fo = [
  Lo,
  jo
];
function qo(t, l) {
  return o(), r("svg", Vo, [...Fo]);
}
const yo = { render: qo }, bo = (t) => e(s, t, {
  default: () => [e(yo, null, null)]
}), To = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Do = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M4 21h16M18.5 3v7.951a6.5 6.5 0 0 1-13 0V3"
}, null, -1), Zo = [
  Do
];
function Ro(t, l) {
  return o(), r("svg", To, [...Zo]);
}
const Po = { render: Ro }, Io = (t) => e(s, t, {
  default: () => [e(Po, null, null)]
}), No = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Eo = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M2.5 12h19M12 12c8 3 5 10 0 10s-6-4-6-4M18 6s-1.5-4-6-4-6.282 3.8-4.195 7"
}, null, -1), Uo = [
  Eo
];
function Wo(t, l) {
  return o(), r("svg", No, [...Uo]);
}
const Go = { render: Wo }, Jo = (t) => e(s, t, {
  default: () => [e(Go, null, null)]
}), Qo = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Ko = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M21 4v8M3 12v8"
}, null, -1), Xo = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M21 12A9 9 0 0 0 5.524 5.75M3 12a9 9 0 0 0 15.25 6.476"
}, null, -1), Yo = [
  Ko,
  Xo
];
function tr(t, l) {
  return o(), r("svg", Qo, [...Yo]);
}
const er = { render: tr }, nr = (t) => e(s, t, {
  default: () => [e(er, null, null)]
}), lr = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, or = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M7.114 18H16a5 5 0 0 0 5-5v0a5 5 0 0 0-5-5H3"
}, null, -1), rr = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M6.5 5 3 8l3.5 3.5"
}, null, -1), sr = [
  or,
  rr
];
function cr(t, l) {
  return o(), r("svg", lr, [...sr]);
}
const dr = { render: cr }, ir = (t) => e(s, t, {
  default: () => [e(dr, null, null)]
}), ur = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, hr = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M21 8H7.95C5.216 8 3 10.239 3 13s2.216 5 4.95 5H17"
}, null, -1), ar = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M17.5 5 21 8l-3.5 3.5"
}, null, -1), _r = [
  hr,
  ar
];
function vr(t, l) {
  return o(), r("svg", ur, [..._r]);
}
const wr = { render: vr }, fr = (t) => e(s, t, {
  default: () => [e(wr, null, null)]
}), gr = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, $r = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "square",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M5 22h14a1 1 0 0 0 1-1V7h-5V2H5a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1Z"
}, null, -1), pr = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m15 2 5 5"
}, null, -1), xr = [
  $r,
  pr
];
function Mr(t, l) {
  return o(), r("svg", gr, [...xr]);
}
const kr = { render: Mr }, Cr = (t) => e(s, t, {
  default: () => [e(kr, null, null)]
}), mr = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Or = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M20 11.5V7l-4.5-5H5a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h6"
}, null, -1), zr = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M17 15v6M14 18h6"
}, null, -1), Sr = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M15 2v5h5"
}, null, -1), Br = [
  Or,
  zr,
  Sr
];
function Ar(t, l) {
  return o(), r("svg", mr, [...Br]);
}
const Hr = { render: Ar }, Vr = (t) => e(s, t, {
  default: () => [e(Hr, null, null)]
}), Lr = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, jr = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M2.5 4a1 1 0 0 1 1-1h6L12 6h8.5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-17a1 1 0 0 1-1-1z"
}, null, -1), Fr = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M9 13.5h6M12 10.5v6"
}, null, -1), qr = [
  jr,
  Fr
];
function yr(t, l) {
  return o(), r("svg", Lr, [...qr]);
}
const br = { render: yr }, Tr = (t) => e(s, t, {
  default: () => [e(br, null, null)]
}), Dr = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Zr = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.25 21.75A.75.75 0 0 1 10 21h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75M10.25 2.25A.75.75 0 0 1 11 1.5h2A.75.75 0 0 1 13 3h-2a.75.75 0 0 1-.75-.75M12 5.5a5.25 5.25 0 0 0-5.25 5.25v5.5a.75.75 0 0 1-.126.416L5.401 18.5H18.6l-1.223-1.834a.75.75 0 0 1-.126-.416v-5.5c0-2.9-2.35-5.25-5.25-5.25m-6.75 5.25a6.75 6.75 0 0 1 13.5 0v5.273l1.356 2.034A1.25 1.25 0 0 1 19.066 20H4.934a1.25 1.25 0 0 1-1.04-1.943l1.356-2.034z",
  "clip-rule": "evenodd"
}, null, -1), Rr = [
  Zr
];
function Pr(t, l) {
  return o(), r("svg", Dr, [...Rr]);
}
const Ir = { render: Pr }, Nr = (t) => e(s, t, {
  default: () => [e(Ir, null, null)]
}), Er = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Ur = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M3 12h18"
}, null, -1), Wr = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m9 18-6-6 6-6"
}, null, -1), Gr = [
  Ur,
  Wr
];
function Jr(t, l) {
  return o(), r("svg", Er, [...Gr]);
}
const Qr = { render: Jr }, Kr = (t) => e(s, t, {
  default: () => [e(Qr, null, null)]
}), Xr = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Yr = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.844 10.094a.75.75 0 0 0 1.06 1.06l5.594-5.593v3.688a.75.75 0 0 0 1.5 0V3.75a.75.75 0 0 0-.75-.75H14.75a.75.75 0 1 0 0 1.5h3.689zM9.25 20.998a.75.75 0 0 0 0-1.5H5.56l5.595-5.594a.75.75 0 1 0-1.061-1.06L4.5 18.438v-3.689a.75.75 0 0 0-1.5 0v5.5a.747.747 0 0 0 .75.75z",
  "clip-rule": "evenodd"
}, null, -1), t7 = [
  Yr
];
function e7(t, l) {
  return o(), r("svg", Xr, [...t7]);
}
const n7 = { render: e7 }, l7 = (t) => e(s, t, {
  default: () => [e(n7, null, null)]
}), o7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, r7 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M20.779 4.28a.75.75 0 0 0-1.061-1.06l-5.594 5.594v-3.69a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 .75.75h5.4990000000000006a.75.75 0 0 0 0-1.5h-3.688zM5.125 12.624a.75.75 0 0 0 0 1.5h3.689L3.22 19.718a.75.75 0 1 0 1.06 1.06l5.594-5.593v3.688a.75.75 0 0 0 1.5 0v-5.499a.75.75 0 0 0-.458-.691.8.8 0 0 0-.292-.059z",
  "clip-rule": "evenodd"
}, null, -1), s7 = [
  r7
];
function c7(t, l) {
  return o(), r("svg", o7, [...s7]);
}
const d7 = { render: c7 }, i7 = (t) => e(s, t, {
  default: () => [e(d7, null, null)]
}), u7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, h7 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M12 22c2.98 0 1.168-4.432 3-6.5 1.563-1.765 7-.957 7-3.5 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10Zm0 0c2.98 0 1.168-4.432 3-6.5 1.563-1.765 7-.957 7-3.5 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10Z"
}, null, -1), a7 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M12.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM17.5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM7.5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
}, null, -1), _7 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "M9.5 18.327a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
}, null, -1), v7 = [
  h7,
  a7,
  _7
];
function w7(t, l) {
  return o(), r("svg", u7, [...v7]);
}
const f7 = { render: w7 }, g7 = (t) => e(s, t, {
  default: () => [e(f7, null, null)]
}), $7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, p7 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.602 2.102a2.35 2.35 0 0 1 2.796 0l7.4 5.482c.599.443.952 1.144.952 1.888V20.4a2.35 2.35 0 0 1-2.35 2.35H4.6a2.35 2.35 0 0 1-2.35-2.35V9.472c0-.744.353-1.445.951-1.888zm1.904 1.206a.85.85 0 0 0-1.012 0l-7.4 5.482a.85.85 0 0 0-.344.682V20.4c0 .47.38.85.85.85h3.65V16.6a2.35 2.35 0 0 1 2.35-2.35h2.8l.24.011a2.35 2.35 0 0 1 2.11 2.338v4.65h3.65c.47 0 .85-.38.85-.849V9.472a.85.85 0 0 0-.344-.682zM10.6 15.75a.85.85 0 0 0-.85.85v4.65h4.5V16.6a.85.85 0 0 0-.763-.847l-.087-.003z",
  "clip-rule": "evenodd"
}, null, -1), x7 = [
  p7
];
function M7(t, l) {
  return o(), r("svg", $7, [...x7]);
}
const k7 = { render: M7 }, C7 = (t) => e(s, t, {
  default: () => [e(k7, null, null)]
}), m7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, O7 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M13.077 16.254a.75.75 0 0 1 0 1.492L13 17.75H7a.75.75 0 0 1 0-1.5h6zM17.077 12.254a.75.75 0 0 1 0 1.492L17 13.75H7a.75.75 0 0 1 0-1.5h10z"
}, null, -1), z7 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17 2.25c.199 0 .39.08.53.22L21.061 6l.157.173c.342.418.532.944.532 1.49V19.4a2.35 2.35 0 0 1-2.35 2.35H4.6a2.35 2.35 0 0 1-2.35-2.35V4.6A2.35 2.35 0 0 1 4.6 2.25zM4.6 3.75a.85.85 0 0 0-.85.85v14.8c0 .47.38.85.85.85h14.8c.47 0 .85-.38.85-.85V7.663a.85.85 0 0 0-.192-.539L20 7.062 16.689 3.75H12.75V7A1.75 1.75 0 0 1 11 8.75H8A1.75 1.75 0 0 1 6.25 7V3.75zM7.75 7c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25V3.75h-3.5z",
  "clip-rule": "evenodd"
}, null, -1), S7 = [
  O7,
  z7
];
function B7(t, l) {
  return o(), r("svg", m7, [...S7]);
}
const A7 = { render: B7 }, H7 = (t) => e(s, t, {
  default: () => [e(A7, null, null)]
}), V7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, L7 = /* @__PURE__ */ n("rect", {
  width: "18",
  height: "18",
  x: "3",
  y: "3",
  stroke: "currentColor",
  "stroke-width": "1.5",
  rx: "2"
}, null, -1), j7 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M12 8v8M8 12h8"
}, null, -1), F7 = [
  L7,
  j7
];
function q7(t, l) {
  return o(), r("svg", V7, [...F7]);
}
const y7 = { render: q7 }, b7 = (t) => e(s, t, {
  default: () => [e(y7, null, null)]
}), T7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, D7 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M18.106 2.25a3.645 3.645 0 0 1 0 7.29h-2.144v4.92h2.143a3.645 3.645 0 1 1-3.644 3.645v-2.143H9.539v2.143a3.645 3.645 0 1 1-3.644-3.644H8.13V9.539H5.895a3.645 3.645 0 1 1 3.644-3.644V8.13h4.922V5.895a3.645 3.645 0 0 1 3.644-3.645M5.894 15.96a2.145 2.145 0 1 0 2.144 2.145v-2.144zm10.066 2.145a2.145 2.145 0 1 0 2.144-2.144h-2.144zM9.63 14.462h4.832V9.63H9.63zM5.895 3.75a2.145 2.145 0 0 0 0 4.29h2.144V5.894c0-1.185-.96-2.145-2.144-2.145m12.21 0c-1.184 0-2.144.96-2.144 2.145v2.144h2.144a2.145 2.145 0 0 0 0-4.289",
  "clip-rule": "evenodd"
}, null, -1), Z7 = [
  D7
];
function R7(t, l) {
  return o(), r("svg", T7, [...Z7]);
}
const P7 = { render: R7 }, I7 = (t) => e(s, t, {
  default: () => [e(P7, null, null)]
}), N7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, E7 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M12 9.027a.75.75 0 0 1 0 1.5h-1.833a.75.75 0 0 0-.75.75v7c0 .415.336.75.75.75H20.5a.75.75 0 0 0 .75-.75v-7a.75.75 0 0 0-.75-.75h-1.833l-.077-.004a.75.75 0 0 1 0-1.492l.077-.004H20.5a2.25 2.25 0 0 1 2.25 2.25v7a2.25 2.25 0 0 1-2.25 2.25H10.167a2.25 2.25 0 0 1-2.25-2.25v-7a2.25 2.25 0 0 1 2.25-2.25z"
}, null, -1), U7 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M13.833 3.473a2.25 2.25 0 0 1 2.25 2.25v7a2.25 2.25 0 0 1-2.25 2.25H12a.75.75 0 0 1 0-1.5h1.833a.75.75 0 0 0 .75-.75v-7a.75.75 0 0 0-.75-.75H3.5a.75.75 0 0 0-.75.75v7c0 .414.336.75.75.75h1.833l.077.004a.75.75 0 0 1 0 1.492l-.077.004H3.5a2.25 2.25 0 0 1-2.25-2.25v-7a2.25 2.25 0 0 1 2.25-2.25z"
}, null, -1), W7 = [
  E7,
  U7
];
function G7(t, l) {
  return o(), r("svg", N7, [...W7]);
}
const J7 = { render: G7 }, Q7 = (t) => e(s, t, {
  default: () => [e(J7, null, null)]
}), K7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, X7 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M21.25 5.5a.75.75 0 0 0-.75-.75h-17a.75.75 0 0 0-.75.75v13c0 .414.336.75.75.75h17a.75.75 0 0 0 .75-.75zm1.5 13a2.25 2.25 0 0 1-2.25 2.25h-17a2.25 2.25 0 0 1-2.25-2.25v-13A2.25 2.25 0 0 1 3.5 3.25h17a2.25 2.25 0 0 1 2.25 2.25z"
}, null, -1), Y7 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M6 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2M9 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2M12 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2M15 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2M18 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2M6 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2M9 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2M12 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2M15 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2M18 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2M6 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2M18 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15 15.25l.077.004a.75.75 0 0 1 0 1.492L15 16.75H9a.75.75 0 0 1 0-1.5z"
}, null, -1), t4 = [
  X7,
  Y7
];
function e4(t, l) {
  return o(), r("svg", K7, [...t4]);
}
const n4 = { render: e4 }, l4 = (t) => e(s, t, {
  default: () => [e(n4, null, null)]
}), o4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, r4 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.542 13.12a1.5 1.5 0 0 1 1.339 1.338l.008.153v2.945a4.444 4.444 0 0 1-4.216 4.438L6.444 22A4.445 4.445 0 0 1 2 17.556l.006-.229a4.445 4.445 0 0 1 4.21-4.21l.228-.006H9.39zM6.444 14.61a2.944 2.944 0 1 0 2.945 2.945V14.61zM17.556 13.111l.228.006a4.445 4.445 0 0 1 4.21 4.21l.006.229A4.445 4.445 0 0 1 17.556 22l-.229-.006a4.444 4.444 0 0 1-4.216-4.438V14.61l.008-.153a1.5 1.5 0 0 1 1.339-1.339l.153-.008zm-2.945 1.5v2.945a2.945 2.945 0 1 0 2.945-2.945zM6.673 2.006a4.444 4.444 0 0 1 4.216 4.438V9.39l-.008.153a1.5 1.5 0 0 1-1.339 1.339l-.153.008H6.444l-.228-.006a4.445 4.445 0 0 1-4.21-4.21L2 6.444A4.445 4.445 0 0 1 6.444 2zM6.444 3.5a2.944 2.944 0 0 0 0 5.889H9.39V6.444A2.944 2.944 0 0 0 6.444 3.5M17.556 2A4.445 4.445 0 0 1 22 6.444l-.006.229a4.445 4.445 0 0 1-4.21 4.21l-.228.006H14.61l-.153-.008a1.5 1.5 0 0 1-1.339-1.339l-.008-.153V6.444a4.444 4.444 0 0 1 4.216-4.438zm0 1.5a2.944 2.944 0 0 0-2.945 2.944V9.39h2.945a2.944 2.944 0 0 0 0-5.889",
  "clip-rule": "evenodd"
}, null, -1), s4 = [
  r4
];
function c4(t, l) {
  return o(), r("svg", o4, [...s4]);
}
const d4 = { render: c4 }, i4 = (t) => e(s, t, {
  default: () => [e(d4, null, null)]
}), u4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, h4 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.151 3.738c.967-.377 2.235-.443 3.777-.176L13.5 3.5l.43.062c.09.017.152.095.152.183l-.004.038-.254 1.25a.2.2 0 0 1-.231.157l-.06-.01c-.991-.168-1.789-.18-2.407-.016l-.254.08a1.9 1.9 0 0 0-1.165 1.178l-.075.245c-.074.29-.145.573-.222.886l-.254 1.055-.08.346h2.445a.2.2 0 0 1 .196.161l.004.04-.005 1.264a.2.2 0 0 1-.2.2h-2.83l-.248 1.071v.004l-.021.093v.002c-.71 3.075-1.042 4.5-1.364 5.661v.001l-.006.024a3.87 3.87 0 0 1-.99 1.931l-.227.22a3.86 3.86 0 0 1-1.956.934H3.87l-.305.037.171-.02-.18.02a.15.15 0 0 1-.156-.15v-1.318c0-.103.078-.187.177-.2l.106-.016h.01l.161-.038c.375-.098.693-.281.954-.567l.105-.126c.238-.306.412-.697.542-1.17l.246-.926c.26-1.022.582-2.392 1.098-4.666v-.007l.02-.089v-.002l.164-.7H4.71a.2.2 0 0 1-.2-.201V9.159c0-.11.09-.2.2-.2h2.655l.05-.216.342-1.44c.092-.38.176-.72.258-1.046h-.002l.009-.034.017-.066c.317-1.146.977-1.912 1.924-2.34zM15.343 8.959a.2.2 0 0 1 .178.11l1.28 2.498 2.296-2.542.03-.028a.2.2 0 0 1 .118-.038H20.4a.2.2 0 0 1 .197.16l.004.041-.004 1.259a.2.2 0 0 1-.2.2h-.513L17.6 13.14l1.197 2.334.077.152h.406c.11 0 .2.09.2.2v1.262a.2.2 0 0 1-.2.2h-1.294a.2.2 0 0 1-.177-.11l-1.395-2.718-2.502 2.766a.2.2 0 0 1-.147.066h-1.292a.2.2 0 0 1-.2-.2V15.83c0-.11.09-.2.2-.2h.646l.084-.093 2.4-2.658-.087-.173-.99-1.933-.079-.153h-.862a.2.2 0 0 1-.2-.2V9.159c0-.11.09-.2.2-.2z",
  "clip-rule": "evenodd"
}, null, -1), a4 = [
  h4
];
function _4(t, l) {
  return o(), r("svg", u4, [...a4]);
}
const v4 = { render: _4 }, w4 = (t) => e(s, t, {
  default: () => [e(v4, null, null)]
}), f4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, g4 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M19 2.25c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 19 7.75h-3A1.75 1.75 0 0 1 14.25 6v-.25H11a.25.25 0 0 0-.25.25v5.25h3.5V11c0-.966.784-1.75 1.75-1.75h3c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 19 14.75h-3A1.75 1.75 0 0 1 14.25 13v-.25h-3.5V18c0 .138.112.25.25.25h3.25V18c0-.966.784-1.75 1.75-1.75h3c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 19 21.75h-3A1.75 1.75 0 0 1 14.25 20v-.25H11A1.75 1.75 0 0 1 9.25 18v-5.25h-1.5V15A1.75 1.75 0 0 1 6 16.75H4A1.75 1.75 0 0 1 2.25 15V9c0-.966.784-1.75 1.75-1.75h2c.966 0 1.75.784 1.75 1.75v2.25h1.5V6c0-.966.784-1.75 1.75-1.75h3.25V4c0-.966.784-1.75 1.75-1.75zm-3 15.5a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25zm-12-9a.25.25 0 0 0-.25.25v6c0 .138.112.25.25.25h2a.25.25 0 0 0 .25-.25V9A.25.25 0 0 0 6 8.75zm12 2a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25zm0-7a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25V4a.25.25 0 0 0-.25-.25z",
  "clip-rule": "evenodd"
}, null, -1), $4 = [
  g4
];
function p4(t, l) {
  return o(), r("svg", f4, [...$4]);
}
const x4 = { render: p4 }, M4 = (t) => e(s, t, {
  default: () => [e(x4, null, null)]
}), k4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, C4 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M4 3v18"
}, null, -1), m4 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M8 6.25a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75zM14 6.25a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75z"
}, null, -1), O4 = [
  C4,
  m4
];
function z4(t, l) {
  return o(), r("svg", k4, [...O4]);
}
const S4 = { render: z4 }, B4 = (t) => e(s, t, {
  default: () => [e(S4, null, null)]
}), A4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, H4 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M12 3v18"
}, null, -1), V4 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M6 6.25a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75V7A.75.75 0 0 0 8 6.25zM16 6.25a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75z"
}, null, -1), L4 = [
  H4,
  V4
];
function j4(t, l) {
  return o(), r("svg", A4, [...L4]);
}
const F4 = { render: j4 }, q4 = (t) => e(s, t, {
  default: () => [e(F4, null, null)]
}), y4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, b4 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M14 6.25a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75zM8 6.25a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75z"
}, null, -1), T4 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M20 3v18"
}, null, -1), D4 = [
  b4,
  T4
];
function Z4(t, l) {
  return o(), r("svg", y4, [...D4]);
}
const R4 = { render: Z4 }, P4 = (t) => e(s, t, {
  default: () => [e(R4, null, null)]
}), I4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, N4 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M4.75 3a.75.75 0 0 0-1.5 0v18a.75.75 0 0 0 1.5 0v-4.293a.8.8 0 0 0 .25.043h2a.75.75 0 0 0 .75-.75V7A.75.75 0 0 0 7 6.25H5a.8.8 0 0 0-.25.043zM19.25 3a.75.75 0 0 1 1.5 0v18a.75.75 0 0 1-1.5 0v-4.293a.8.8 0 0 1-.25.043h-2a.75.75 0 0 1-.75-.75V7a.75.75 0 0 1 .75-.75h2q.133 0 .25.043z"
}, null, -1), E4 = [
  N4
];
function U4(t, l) {
  return o(), r("svg", I4, [...E4]);
}
const W4 = { render: U4 }, G4 = (t) => e(s, t, {
  default: () => [e(W4, null, null)]
}), J4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Q4 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M4 3v18M20 3v18"
}, null, -1), K4 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M7 6.25a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75V7A.75.75 0 0 0 9 6.25zM15 6.25a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75z"
}, null, -1), X4 = [
  Q4,
  K4
];
function Y4(t, l) {
  return o(), r("svg", J4, [...X4]);
}
const t3 = { render: Y4 }, e3 = (t) => e(s, t, {
  default: () => [e(t3, null, null)]
}), n3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, l3 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M21 4H3"
}, null, -1), o3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M7.25 10c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75V8a.75.75 0 0 0-.75-.75H8a.75.75 0 0 0-.75.75zM7.25 16c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 0-.75-.75H8a.75.75 0 0 0-.75.75z"
}, null, -1), r3 = [
  l3,
  o3
];
function s3(t, l) {
  return o(), r("svg", n3, [...r3]);
}
const c3 = { render: s3 }, d3 = (t) => e(s, t, {
  default: () => [e(c3, null, null)]
}), i3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, u3 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M3 12h18"
}, null, -1), h3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M6.25 18c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 0-.75-.75H7a.75.75 0 0 0-.75.75zM6.25 8c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75H7a.75.75 0 0 0-.75.75z"
}, null, -1), a3 = [
  u3,
  h3
];
function _3(t, l) {
  return o(), r("svg", i3, [...a3]);
}
const v3 = { render: _3 }, w3 = (t) => e(s, t, {
  default: () => [e(v3, null, null)]
}), f3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, g3 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M3 20h18"
}, null, -1), $3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M6.25 16c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 0-.75-.75H7a.75.75 0 0 0-.75.75zM6.25 10c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75V8a.75.75 0 0 0-.75-.75H7a.75.75 0 0 0-.75.75z"
}, null, -1), p3 = [
  g3,
  $3
];
function x3(t, l) {
  return o(), r("svg", f3, [...p3]);
}
const M3 = { render: x3 }, k3 = (t) => e(s, t, {
  default: () => [e(M3, null, null)]
}), C3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, m3 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M3 20h18M3 4h18"
}, null, -1), O3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M7 15v2h9v-2zM7 7v2h9V7z"
}, null, -1), z3 = [
  m3,
  O3
];
function S3(t, l) {
  return o(), r("svg", C3, [...z3]);
}
const B3 = { render: S3 }, A3 = (t) => e(s, t, {
  default: () => [e(B3, null, null)]
}), H3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, V3 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M3 20h18M3 4h18"
}, null, -1), L3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M6.25 17c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 0-.75-.75H7a.75.75 0 0 0-.75.75zM6.25 9c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75H7a.75.75 0 0 0-.75.75z"
}, null, -1), j3 = [
  V3,
  L3
];
function F3(t, l) {
  return o(), r("svg", H3, [...j3]);
}
const q3 = { render: F3 }, y3 = (t) => e(s, t, {
  default: () => [e(q3, null, null)]
}), b3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, T3 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M3 20h18M3 4h18"
}, null, -1), D3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M14.546 5.5c-.302 0-.546.323-.546.722v11.556c0 .399.244.722.546.722h2.909c.3 0 .545-.323.545-.722V6.222c0-.399-.244-.722-.546-.722zM6.545 5.5c-.3 0-.545.323-.545.722v11.556c0 .399.244.722.545.722h2.91c.3 0 .545-.323.545-.722V6.222c0-.399-.244-.722-.545-.722z"
}, null, -1), Z3 = [
  T3,
  D3
];
function R3(t, l) {
  return o(), r("svg", b3, [...Z3]);
}
const P3 = { render: R3 }, I3 = (t) => e(s, t, {
  default: () => [e(P3, null, null)]
}), N3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, E3 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M3 20h18"
}, null, -1), U3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M10.896 3.5h2.208L18 16.352h-2.083l-1.193-3.416H9.258l-1.193 3.416H6zm-1.05 7.834h4.29l-2.1-5.75h-.072z"
}, null, -1), W3 = [
  E3,
  U3
];
function G3(t, l) {
  return o(), r("svg", N3, [...W3]);
}
const J3 = { render: G3 }, Q3 = (t) => e(s, t, {
  default: () => [e(J3, null, null)]
}), K3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, X3 = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M5 4h5v7H5z"
}, null, -1), Y3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M14 3.25a.75.75 0 0 0-.75.75v7c0 .414.336.75.75.75h5a.75.75 0 0 0 .75-.75V4a.75.75 0 0 0-.75-.75z"
}, null, -1), ts = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.53 14.47a.75.75 0 1 0-1.06 1.06l1.72 1.72H4.75a.75.75 0 0 0 0 1.5h12.44l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06z",
  "clip-rule": "evenodd"
}, null, -1), es = [
  X3,
  Y3,
  ts
];
function ns(t, l) {
  return o(), r("svg", K3, [...es]);
}
const ls = { render: ns }, os = (t) => e(s, t, {
  default: () => [e(ls, null, null)]
}), rs = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, ss = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M5 3.25a.75.75 0 0 0-.75.75v7c0 .414.336.75.75.75h5a.75.75 0 0 0 .75-.75V4a.75.75 0 0 0-.75-.75z"
}, null, -1), cs = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M14 4h5v7h-5z"
}, null, -1), ds = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.22 14.47a.75.75 0 0 1 1.06 1.06l-1.72 1.72H19a.75.75 0 0 1 0 1.5H6.56l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06z",
  "clip-rule": "evenodd"
}, null, -1), is = [
  ss,
  cs,
  ds
];
function us(t, l) {
  return o(), r("svg", rs, [...is]);
}
const hs = { render: us }, as = (t) => e(s, t, {
  default: () => [e(hs, null, null)]
}), _s = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, vs = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M11.75 5a.75.75 0 0 0-.75-.75H4a.75.75 0 0 0-.75.75v5c0 .414.336.75.75.75h7a.75.75 0 0 0 .75-.75z"
}, null, -1), ws = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M4 19v-5h7v5z"
}, null, -1), fs = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M21.53 16.53a.75.75 0 1 0-1.06-1.06l-1.72 1.72V4.75a.75.75 0 0 0-1.5 0v12.44l-1.72-1.72a.75.75 0 1 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0z",
  "clip-rule": "evenodd"
}, null, -1), gs = [
  vs,
  ws,
  fs
];
function $s(t, l) {
  return o(), r("svg", _s, [...gs]);
}
const ps = { render: $s }, xs = (t) => e(s, t, {
  default: () => [e(ps, null, null)]
}), Ms = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, ks = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M4 10V5h7v5z"
}, null, -1), Cs = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M11.75 14a.75.75 0 0 0-.75-.75H4a.75.75 0 0 0-.75.75v5c0 .414.336.75.75.75h7a.75.75 0 0 0 .75-.75z"
}, null, -1), ms = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.47 7.22a.75.75 0 0 0 1.06 1.06l1.72-1.72V19a.75.75 0 0 0 1.5 0V6.56l1.72 1.72a.75.75 0 1 0 1.06-1.06l-3-3a.75.75 0 0 0-1.06 0z",
  "clip-rule": "evenodd"
}, null, -1), Os = [
  ks,
  Cs,
  ms
];
function zs(t, l) {
  return o(), r("svg", Ms, [...Os]);
}
const Ss = { render: zs }, Bs = (t) => e(s, t, {
  default: () => [e(Ss, null, null)]
}), As = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Hs = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M3 14v-4h7v4z"
}, null, -1), Vs = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M10.75 17a.75.75 0 0 0-.75-.75H3a.75.75 0 0 0-.75.75v4c0 .414.336.75.75.75h7a.75.75 0 0 0 .75-.75zM10.75 3a.75.75 0 0 0-.75-.75H3a.75.75 0 0 0-.75.75v4c0 .414.336.75.75.75h7a.75.75 0 0 0 .75-.75zM21.75 10a.75.75 0 0 0-.75-.75h-7a.75.75 0 0 0-.75.75v4c0 .414.336.75.75.75h7a.75.75 0 0 0 .75-.75z"
}, null, -1), Ls = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M14 21v-4h7v4zM14 7V3h7v4z"
}, null, -1), js = [
  Hs,
  Vs,
  Ls
];
function Fs(t, l) {
  return o(), r("svg", As, [...js]);
}
const qs = { render: Fs }, ys = (t) => e(s, t, {
  default: () => [e(qs, null, null)]
}), bs = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Ts = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M10 7.75a.75.75 0 0 0-.75.75v7c0 .414.336.75.75.75h4a.75.75 0 0 0 .75-.75v-7a.75.75 0 0 0-.75-.75z"
}, null, -1), Ds = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M21.75 15.5a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75v-7a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75zm-1.5-.75v-5.5h-2.5v5.5zM7.75 15.5a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75v-7A.75.75 0 0 1 3 7.75h4a.75.75 0 0 1 .75.75zm-1.5-.75v-5.5h-2.5v5.5z",
  "clip-rule": "evenodd"
}, null, -1), Zs = [
  Ts,
  Ds
];
function Rs(t, l) {
  return o(), r("svg", bs, [...Zs]);
}
const Ps = { render: Rs }, Is = (t) => e(s, t, {
  default: () => [e(Ps, null, null)]
}), Ns = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Es = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M20.5 3h-17A1.5 1.5 0 0 0 2 4.5v15A1.5 1.5 0 0 0 3.5 21h17a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 20.5 3ZM2 7h20M10 12h8M10 16h8M6 12h1M6 16h1"
}, null, -1), Us = [
  Es
];
function Ws(t, l) {
  return o(), r("svg", Ns, [...Us]);
}
const Gs = { render: Ws }, Js = (t) => e(s, t, {
  default: () => [e(Gs, null, null)]
}), Qs = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Ks = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Z"
}, null, -1), Xs = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "square",
  "stroke-width": "1.5",
  d: "M3 9h18M3 15h18M9 3v18M15 3v18"
}, null, -1), Ys = [
  Ks,
  Xs
];
function tc(t, l) {
  return o(), r("svg", Qs, [...Ys]);
}
const ec = { render: tc }, nc = (t) => e(s, t, {
  default: () => [e(ec, null, null)]
}), lc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, oc = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Z"
}, null, -1), rc = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M7 7h6M7 10v8"
}, null, -1), sc = /* @__PURE__ */ n("rect", {
  width: "6",
  height: "8",
  x: "11",
  y: "10",
  stroke: "currentColor",
  "stroke-width": "1.5",
  rx: "1"
}, null, -1), cc = /* @__PURE__ */ n("circle", {
  cx: "17",
  cy: "7",
  r: "1",
  fill: "currentColor"
}, null, -1), dc = [
  oc,
  rc,
  sc,
  cc
];
function ic(t, l) {
  return o(), r("svg", lc, [...dc]);
}
const uc = { render: ic }, hc = (t) => e(s, t, {
  default: () => [e(uc, null, null)]
}), ac = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, _c = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Z"
}, null, -1), vc = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "square",
  "stroke-width": "1.5",
  d: "M3 8h18M8.5 15H21M8.5 8v13"
}, null, -1), wc = [
  _c,
  vc
];
function fc(t, l) {
  return o(), r("svg", ac, [...wc]);
}
const gc = { render: fc }, $c = (t) => e(s, t, {
  default: () => [e(gc, null, null)]
}), pc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, xc = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Z"
}, null, -1), Mc = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M4.786 9.273h2.289q.68 0 1.012.059.336.055.597.234.266.18.442.48.176.298.176.669 0 .402-.22.738a1.33 1.33 0 0 1-.585.504q.523.153.805.52.28.366.28.863a1.7 1.7 0 0 1-.183.762q-.18.366-.496.59a1.64 1.64 0 0 1-.773.269q-.29.03-1.395.039h-1.95zm1.156.954v1.324H6.7q.675 0 .84-.02a.76.76 0 0 0 .465-.203.6.6 0 0 0 .172-.45q0-.265-.149-.429-.144-.168-.433-.203-.172-.02-.989-.02zm0 2.277v1.531h1.07q.626 0 .793-.035a.7.7 0 0 0 .418-.227.7.7 0 0 0 .165-.488.75.75 0 0 0-.125-.437.7.7 0 0 0-.364-.262q-.234-.082-1.023-.082zM11.532 15v-4.758H9.833v-.969h4.55v.97H12.69V15zm3.294 0V9.273h1.125l2.343 3.825V9.273h1.075V15h-1.16l-2.31-3.734V15z"
}, null, -1), kc = [
  xc,
  Mc
];
function Cc(t, l) {
  return o(), r("svg", pc, [...kc]);
}
const mc = { render: Cc }, Oc = (t) => e(s, t, {
  default: () => [e(mc, null, null)]
}), zc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Sc = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Z"
}, null, -1), Bc = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M8.148 15H7.051v-4.137a3.8 3.8 0 0 1-1.418.832V10.7q.429-.14.933-.531.504-.395.692-.918h.89zm5.592-1.02V15H9.892q.063-.578.375-1.094.313-.519 1.235-1.375.741-.69.91-.937.226-.34.226-.672 0-.367-.199-.563-.195-.199-.543-.199-.343 0-.547.207-.203.207-.234.688l-1.094-.11q.098-.906.613-1.3.516-.395 1.29-.395.848 0 1.332.457a1.5 1.5 0 0 1 .484 1.137q0 .387-.14.738a3 3 0 0 1-.438.73q-.2.255-.719.731-.519.477-.66.633a2 2 0 0 0-.223.304zm.947-.5 1.063-.128q.05.405.273.62a.75.75 0 0 0 .539.216.73.73 0 0 0 .57-.258q.235-.258.235-.696 0-.413-.223-.656a.71.71 0 0 0-.543-.242q-.21 0-.504.082l.121-.895q.446.012.68-.191a.7.7 0 0 0 .234-.547.62.62 0 0 0-.172-.46.62.62 0 0 0-.457-.173.66.66 0 0 0-.48.196q-.2.195-.242.57l-1.012-.172q.106-.519.316-.828.216-.312.594-.488.382-.18.856-.18.808 0 1.297.516.402.421.402.953 0 .753-.824 1.203.492.105.785.473.297.366.297.886 0 .754-.551 1.285-.55.532-1.371.532-.777 0-1.29-.446-.51-.45-.593-1.171"
}, null, -1), Ac = [
  Sc,
  Bc
];
function Hc(t, l) {
  return o(), r("svg", zc, [...Ac]);
}
const Vc = { render: Hc }, Lc = (t) => e(s, t, {
  default: () => [e(Vc, null, null)]
}), jc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Fc = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Z"
}, null, -1), qc = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "square",
  "stroke-width": "1.5",
  d: "M8 8h8M12 8v8"
}, null, -1), yc = [
  Fc,
  qc
];
function bc(t, l) {
  return o(), r("svg", jc, [...yc]);
}
const Tc = { render: bc }, Dc = (t) => e(s, t, {
  default: () => [e(Tc, null, null)]
}), Zc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Rc = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Z"
}, null, -1), Pc = /* @__PURE__ */ n("path", {
  stroke: "currentColor",
  "stroke-linecap": "square",
  "stroke-width": "1.5",
  d: "M6 8h8M14 14h3M14 16h3M10 8v8"
}, null, -1), Ic = [
  Rc,
  Pc
];
function Nc(t, l) {
  return o(), r("svg", Zc, [...Ic]);
}
const Ec = { render: Nc }, Uc = (t) => e(s, t, {
  default: () => [e(Ec, null, null)]
}), Wc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Gc = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M9.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M9.5 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M9.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14.5 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
}, null, -1), Jc = [
  Gc
];
function Qc(t, l) {
  return o(), r("svg", Wc, [...Jc]);
}
const Kc = { render: Qc }, Xc = (t) => e(s, t, {
  default: () => [e(Kc, null, null)]
}), Yc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, td = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M21.5 11.5h-13a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1M4 13.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m-.875-1.698.177-.177.448.448.948-.948.177.177-1.125 1.125z"
}, null, -1), ed = [
  td
];
function nd(t, l) {
  return o(), r("svg", Yc, [...ed]);
}
const ld = { render: nd }, od = (t) => e(s, t, {
  default: () => [e(ld, null, null)]
}), rd = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, sd = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M8 10v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1"
}, null, -1), cd = /* @__PURE__ */ n("path", {
  fill: "#fff",
  d: "M19.5 11.5h-9a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1"
}, null, -1), dd = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M4 13.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m-.875-1.698.177-.177.448.448.948-.948.177.177-1.125 1.125z"
}, null, -1), id = [
  sd,
  cd,
  dd
];
function ud(t, l) {
  return o(), r("svg", rd, [...id]);
}
const hd = { render: ud }, ad = (t) => e(s, t, {
  default: () => [e(hd, null, null)]
}), _d = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, vd = /* @__PURE__ */ n("g", { "fill-rule": "nonzero" }, [
  /* @__PURE__ */ n("path", {
    fill: "currentColor",
    d: "M8.724 3.553A1 1 0 0 1 9.618 3h4.764a1 1 0 0 1 .894.553L16.5 6h4A1.5 1.5 0 0 1 22 7.5v12a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 19.5v-12A1.5 1.5 0 0 1 3.5 6h4z"
  }),
  /* @__PURE__ */ n("path", {
    fill: "#FFF",
    d: "M12 17.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  }),
  /* @__PURE__ */ n("path", {
    fill: "currentColor",
    d: "M12 16a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  })
], -1), wd = [
  vd
];
function fd(t, l) {
  return o(), r("svg", _d, [...wd]);
}
const gd = { render: fd }, $d = (t) => e(s, t, {
  default: () => [e(gd, null, null)]
}), pd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, xd = /* @__PURE__ */ n("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, [
  /* @__PURE__ */ n("path", {
    "fill-opacity": ".85",
    d: "M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
  }),
  /* @__PURE__ */ n("path", {
    fill: "#FFF",
    d: "M16.799 9.348a.714.714 0 0 0-1.01.006l-5.208 5.264-2.305-2.369a.714.714 0 1 0-1.024.996l2.813 2.89q.002.003.006.005l.003.006c.045.044.101.071.154.101.028.015.05.04.078.052a.7.7 0 0 0 .538.001c.027-.011.049-.034.075-.049.054-.03.11-.056.155-.101l.005-.006.005-.004 5.72-5.781a.715.715 0 0 0-.005-1.011"
  })
], -1), Md = [
  xd
];
function kd(t, l) {
  return o(), r("svg", pd, [...Md]);
}
const Cd = { render: kd }, md = (t) => e(s, t, {
  default: () => [e(Cd, null, null)]
}), Od = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, zd = /* @__PURE__ */ n("g", {
  fill: "currentColor",
  "fill-rule": "evenodd"
}, [
  /* @__PURE__ */ n("rect", {
    width: "18",
    height: "18",
    x: "3",
    y: "3",
    rx: "2"
  }),
  /* @__PURE__ */ n("path", {
    fill: "#FFF",
    "fill-rule": "nonzero",
    d: "M16.749 8.207a.714.714 0 0 0-1.01.005l-5.208 5.265-2.305-2.369a.714.714 0 1 0-1.024.996l2.813 2.89q.002.003.006.005l.003.005c.045.045.101.072.154.102.028.015.05.04.078.051a.7.7 0 0 0 .538.002c.027-.012.049-.035.075-.049.054-.03.11-.056.155-.101q.002-.004.005-.006l.005-.004 5.72-5.782a.715.715 0 0 0-.005-1.01"
  })
], -1), Sd = [
  zd
];
function Bd(t, l) {
  return o(), r("svg", Od, [...Sd]);
}
const Ad = { render: Bd }, Hd = (t) => e(s, t, {
  default: () => [e(Ad, null, null)]
}), Vd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Ld = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M11.969 1.846c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10m4.08 13.08a.714.714 0 1 1-1.012 1.009l-3.072-3.081-3.081 3.048a.714.714 0 1 1-1.004-1.015l3.078-3.045L7.89 8.766a.714.714 0 1 1 1.012-1.009l3.07 3.08 3.082-3.048a.714.714 0 1 1 1.004 1.016l-3.078 3.044z"
}, null, -1), jd = [
  Ld
];
function Fd(t, l) {
  return o(), r("svg", Vd, [...jd]);
}
const qd = { render: Fd }, yd = (t) => e(s, t, {
  default: () => [e(qd, null, null)]
}), bd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Td = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /* @__PURE__ */ n("path", { d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ n("path", {
    fill: "currentColor",
    "fill-opacity": ".85",
    d: "M3 9.92c0 1.332.53 2.61 1.471 3.551l7.31 7.31c.121.121.317.121.438 0l7.31-7.31A5.02 5.02 0 0 0 21 9.92c0-4.37-5.196-6.656-8.418-3.703L12 6.75l-.582-.534C8.196 3.263 3 5.548 3 9.92"
  })
], -1), Dd = [
  Td
];
function Zd(t, l) {
  return o(), r("svg", bd, [...Dd]);
}
const Rd = { render: Zd }, Pd = (t) => e(s, t, {
  default: () => [e(Rd, null, null)]
}), Id = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Nd = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M11.326 1.67a.75.75 0 0 1 1.345-.003l2.921 5.886 6.516.95a.75.75 0 0 1 .488 1.199l-.071.08-4.739 4.64 1.126 6.449a.75.75 0 0 1-1 .833l-.092-.042-5.821-3.103-5.819 3.103a.75.75 0 0 1-1.103-.69l.012-.102 1.133-6.449-4.746-4.64a.75.75 0 0 1 .312-1.255l.104-.023 6.551-.95z"
}, null, -1), Ed = [
  Nd
];
function Ud(t, l) {
  return o(), r("svg", Id, [...Ed]);
}
const Wd = { render: Ud }, Gd = (t) => e(s, t, {
  default: () => [e(Wd, null, null)]
}), Jd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, Qd = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m.717 15.022a.717.717 0 1 1-1.434 0v-6.457a.717.717 0 1 1 1.434 0zM12 8.412a1.077 1.077 0 1 1 .002-2.153A1.077 1.077 0 0 1 12 8.413"
}, null, -1), Kd = [
  Qd
];
function Xd(t, l) {
  return o(), r("svg", Jd, [...Kd]);
}
const Yd = { render: Xd }, ti = (t) => e(s, t, {
  default: () => [e(Yd, null, null)]
}), ei = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, ni = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10m-.717-15.022a.717.717 0 1 1 1.434 0v6.457a.717.717 0 1 1-1.434 0zm.717 8.61a1.077 1.077 0 1 1-.002 2.153A1.077 1.077 0 0 1 12 15.587"
}, null, -1), li = [
  ni
];
function oi(t, l) {
  return o(), r("svg", ei, [...li]);
}
const ri = { render: oi }, si = (t) => e(s, t, {
  default: () => [e(ri, null, null)]
}), ci = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, di = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M12 22a9.97 9.97 0 0 0 7.071-2.929A9.97 9.97 0 0 0 22 12a9.97 9.97 0 0 0-2.929-7.071A9.97 9.97 0 0 0 12 2a9.97 9.97 0 0 0-7.071 2.929A9.97 9.97 0 0 0 2 12a9.97 9.97 0 0 0 2.929 7.071A9.97 9.97 0 0 0 12 22"
}, null, -1), ii = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.399 4.399A10.72 10.72 0 0 1 12 1.25c2.968 0 5.657 1.204 7.601 3.149l-.53.53.53-.53A10.72 10.72 0 0 1 22.75 12c0 2.968-1.204 5.657-3.149 7.601A10.72 10.72 0 0 1 12 22.75a10.72 10.72 0 0 1-7.601-3.149l.53-.53-.53.53A10.72 10.72 0 0 1 1.25 12c0-2.968 1.204-5.657 3.149-7.601M12 2.75a9.22 9.22 0 0 0-6.54 2.71A9.22 9.22 0 0 0 2.75 12a9.22 9.22 0 0 0 2.71 6.54A9.22 9.22 0 0 0 12 21.25a9.22 9.22 0 0 0 6.54-2.71A9.22 9.22 0 0 0 21.25 12a9.22 9.22 0 0 0-2.71-6.54A9.22 9.22 0 0 0 12 2.75",
  "clip-rule": "evenodd"
}, null, -1), ui = /* @__PURE__ */ n("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M8.25 9.313a3.75 3.75 0 1 1 4.977 3.544.9.9 0 0 0-.375.237c-.081.09-.102.163-.102.219v1a.75.75 0 0 1-1.5 0v-1c0-1.003.808-1.639 1.486-1.874A2.251 2.251 0 1 0 9.75 9.313a.75.75 0 0 1-1.5 0M12 19.313a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
  "clip-rule": "evenodd"
}, null, -1), hi = [
  di,
  ii,
  ui
];
function ai(t, l) {
  return o(), r("svg", ci, [...hi]);
}
const _i = { render: ai }, vi = (t) => e(s, t, {
  default: () => [e(_i, null, null)]
}), wi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, fi = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
}, null, -1), gi = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
  "clip-rule": "evenodd"
}, null, -1), $i = /* @__PURE__ */ n("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M9.592 22.736q-.146-.187 0-3.337-1.553.054-1.964-.215c-.41-.27-.82-1.1-1.183-1.686s-1.172-.678-1.498-.809c-.326-.13-.408-.664.899-.26 1.306.403 1.37 1.502 1.782 1.759s1.398.144 1.844-.062.414-.972.494-1.275c.1-.284-.254-.347-.262-.349-.436 0-2.727-.498-3.356-2.716-.63-2.219.181-3.669.613-4.292q.433-.623-.076-2.657Q8.733 6.601 9.737 8c0 .006.877-.521 2.263-.521s1.878.429 2.257.521.683-1.633 3.026-1.163c-.489.962-.899 2.163-.586 2.657s1.54 2.064.786 4.292q-.753 2.227-2.964 2.716-.253.081-.253.261c0 .18.228.2.557 1.043q.33.843.048 4.818-.714.18-1.11.244c-.469.073-.978.115-1.478.13-.5.016-.673.015-1.364-.05a10 10 0 0 1-1.327-.212",
  "clip-rule": "evenodd"
}, null, -1), pi = [
  fi,
  gi,
  $i
];
function xi(t, l) {
  return o(), r("svg", wi, [...pi]);
}
const Mi = { render: xi }, ki = (t) => e(s, t, {
  default: () => [e(Mi, null, null)]
}), Ci = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, mi = /* @__PURE__ */ n("path", {
  stroke: "#000",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M8 3H4a1 1 0 0 0-1 1v4M16 3h4a1 1 0 0 1 1 1v4M8 21H4a1 1 0 0 1-1-1v-4.5M16 21h4a1 1 0 0 0 1-1v-4"
}, null, -1), Oi = /* @__PURE__ */ n("rect", {
  width: "20",
  height: "20",
  x: "2",
  y: "2",
  fill: "#C8C8C8",
  rx: "2"
}, null, -1), zi = /* @__PURE__ */ n("path", {
  fill: "#fff",
  d: "M12 3h7a2 2 0 0 1 2 2v7h-9zM3 12h9v9H5a2 2 0 0 1-2-2z"
}, null, -1), Si = [
  mi,
  Oi,
  zi
];
function Bi(t, l) {
  return o(), r("svg", Ci, [...Si]);
}
const Ai = { render: Bi }, Hi = (t) => e(s, t, {
  default: () => [e(Ai, null, null)]
}), Vi = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Li = /* @__PURE__ */ n("g", {
  fill: "currentColor",
  "clip-path": "url(#clip0_1452_9)"
}, [
  /* @__PURE__ */ n("path", { d: "M12 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" })
], -1), ji = [
  Li
];
function Fi(t, l) {
  return o(), r("svg", Vi, [...ji]);
}
const qi = { render: Fi }, yi = (t) => e(s, t, {
  default: () => [e(qi, null, null)]
}), bi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AlignAroundHOutlined: e3,
  AlignAroundVOutlined: y3,
  AlignBaselineOutlined: Q3,
  AlignBetweenHOutlined: G4,
  AlignBottomOutlined: k3,
  AlignCenterHOutlined: q4,
  AlignCenterVOutlined: w3,
  AlignJustifyVOutlined: A3,
  AlignLeftOutlined: B4,
  AlignRightOutlined: P4,
  AlignStretchOutlined: I3,
  AlignTopOutlined: d3,
  BluetoothOutlined: wt,
  Book1Outlined: Ut,
  BookOutlined: Dt,
  BookmarkOutlined: Xt,
  BorderCircleOutlined: D,
  BorderOutlined: zl,
  BorderSquareOutlined: E,
  ButtonOutlined: Oc,
  CameraFilled: $d,
  CaretDownOutlined: l5,
  CaretLeftOutlined: i5,
  CaretRightOutlined: K0,
  CaretUpOutlined: E0,
  CheckCircleFilled: md,
  CheckCircleOutlined: K,
  CheckOutlined: l1,
  CheckSquareFilled: Hd,
  ChromeOutlined: cl,
  CloseCircleOutlined: i1,
  CloseFilled: yd,
  CloseOutlined: w1,
  CloudOutlined: tn,
  CodeOutlined: w5,
  CodeSandboxOutlined: _l,
  ColorPanelOutlined: g7,
  CommandOutlined: I7,
  ComponentOutlined: go,
  ContainerOutlined: hc,
  CopyOutlined: M5,
  DarkOutlined: St,
  DashboardOutlined: oe,
  DeleteOutlined: cn,
  DesktopOutlined: lo,
  DirectionHorizontalOutlined: os,
  DirectionHorizontalROutlined: as,
  DirectionVerticalOutlined: xs,
  DirectionVerticalROutlined: Bs,
  DoubleLeftOutlined: M1,
  DoubleRightOutlined: S1,
  DownOutlined: E1,
  DragOutlined: Xc,
  EmailOutlined: vn,
  ExpressionOutlined: w4,
  EyeInvisibleOutlined: j5,
  EyeOutlined: S5,
  FilterOutlined: xn,
  FlexNoWrapOutlined: Is,
  FlexWrapOutlined: ys,
  FolderAddOutlined: Tr,
  FolderOpenOutlined: Tn,
  FolderOutlined: Ln,
  FormOutlined: Js,
  FullScreenOutlined: l7,
  GithubFilled: ki,
  GithubOutlined: xl,
  GridOutlined: nc,
  HeartFilled: Pd,
  HeartOutlined: l0,
  HelpFilled: vi,
  HelpOutlined: En,
  HomeOutlined: C7,
  ImageFailOutlined: i0,
  ImageOutlined: w0,
  InternetOutlined: j2,
  KeyboardOutlined: l4,
  LayoutOutlined: $c,
  LeftOutlined: K1,
  LightOutlined: Mt,
  LineThroughOutlined: Jo,
  LinkOpenOutlined: p2,
  LinkOutlined: r2,
  Loading2Outlined: M0,
  LoadingOutlined: S0,
  LocationOutlined: Z2,
  LockOutlined: D5,
  LoginOutlined: G2,
  LogoutOutlined: el,
  MediaOutlined: i4,
  MessageOutlined: Nr,
  MinusOutlined: K5,
  MobileOutlined: ho,
  MoreFilled: yi,
  MosaicFilled: Hi,
  NonFullScreenOutlined: i7,
  NumberInputOutlined: Lc,
  OptionFilled: ad,
  OptionOutlined: od,
  OutlineTreeOutlined: Co,
  PageAddOutlined: Vr,
  PageOutlined: Cr,
  PersonOutlined: ue,
  PersonSettingOutlined: $e,
  PersonShareOutlined: Oe,
  PlusOneOutlined: b7,
  PlusOutlined: lt,
  QrcodeOutlined: it,
  RedoOutlined: fr,
  ReferencesOutlined: Q7,
  RefreshOutlined: nr,
  ReturnArrowOutlined: Kr,
  RightOutlined: D1,
  SaveOutlined: H7,
  SearchOutlined: zn,
  SettingCompleteOutlined: Re,
  SettingOutlined: Le,
  ShareOutlined: O2,
  StarFilled: Gd,
  StarOutlined: j0,
  TagOutlined: Xn,
  TextAlignCenterOutlined: Tl,
  TextAlignJustifyOutlined: Ql,
  TextAlignLeftOutlined: Ll,
  TextAlignRightOutlined: Nl,
  TextInputOutlined: Dc,
  TextItalicOutlined: bo,
  TextOutlined: Ho,
  TextareaOutlined: Uc,
  TipsFilled: ti,
  TipsOutlined: D0,
  TopOutlined: j1,
  UnderlineOutlined: Io,
  UndoOutlined: ir,
  UnlinkOutlined: a2,
  UnlockOutlined: E5,
  VideoOutlined: Ge,
  WarningFilled: si,
  WiFiOutlined: jt,
  WorkflowOutlined: M4
}, Symbol.toStringTag, { value: "Module" })), Di = bi;
export {
  e3 as AlignAroundHOutlined,
  y3 as AlignAroundVOutlined,
  Q3 as AlignBaselineOutlined,
  G4 as AlignBetweenHOutlined,
  k3 as AlignBottomOutlined,
  q4 as AlignCenterHOutlined,
  w3 as AlignCenterVOutlined,
  A3 as AlignJustifyVOutlined,
  B4 as AlignLeftOutlined,
  P4 as AlignRightOutlined,
  I3 as AlignStretchOutlined,
  d3 as AlignTopOutlined,
  wt as BluetoothOutlined,
  Ut as Book1Outlined,
  Dt as BookOutlined,
  Xt as BookmarkOutlined,
  D as BorderCircleOutlined,
  zl as BorderOutlined,
  E as BorderSquareOutlined,
  Oc as ButtonOutlined,
  $d as CameraFilled,
  l5 as CaretDownOutlined,
  i5 as CaretLeftOutlined,
  K0 as CaretRightOutlined,
  E0 as CaretUpOutlined,
  md as CheckCircleFilled,
  K as CheckCircleOutlined,
  l1 as CheckOutlined,
  Hd as CheckSquareFilled,
  cl as ChromeOutlined,
  i1 as CloseCircleOutlined,
  yd as CloseFilled,
  w1 as CloseOutlined,
  tn as CloudOutlined,
  w5 as CodeOutlined,
  _l as CodeSandboxOutlined,
  g7 as ColorPanelOutlined,
  I7 as CommandOutlined,
  go as ComponentOutlined,
  hc as ContainerOutlined,
  M5 as CopyOutlined,
  s as DIcon,
  St as DarkOutlined,
  oe as DashboardOutlined,
  cn as DeleteOutlined,
  lo as DesktopOutlined,
  os as DirectionHorizontalOutlined,
  as as DirectionHorizontalROutlined,
  xs as DirectionVerticalOutlined,
  Bs as DirectionVerticalROutlined,
  M1 as DoubleLeftOutlined,
  S1 as DoubleRightOutlined,
  E1 as DownOutlined,
  Xc as DragOutlined,
  vn as EmailOutlined,
  w4 as ExpressionOutlined,
  j5 as EyeInvisibleOutlined,
  S5 as EyeOutlined,
  xn as FilterOutlined,
  Is as FlexNoWrapOutlined,
  ys as FlexWrapOutlined,
  Tr as FolderAddOutlined,
  Tn as FolderOpenOutlined,
  Ln as FolderOutlined,
  Js as FormOutlined,
  l7 as FullScreenOutlined,
  ki as GithubFilled,
  xl as GithubOutlined,
  nc as GridOutlined,
  Pd as HeartFilled,
  l0 as HeartOutlined,
  vi as HelpFilled,
  En as HelpOutlined,
  C7 as HomeOutlined,
  i0 as ImageFailOutlined,
  w0 as ImageOutlined,
  j2 as InternetOutlined,
  l4 as KeyboardOutlined,
  $c as LayoutOutlined,
  K1 as LeftOutlined,
  Mt as LightOutlined,
  Jo as LineThroughOutlined,
  p2 as LinkOpenOutlined,
  r2 as LinkOutlined,
  M0 as Loading2Outlined,
  S0 as LoadingOutlined,
  Z2 as LocationOutlined,
  D5 as LockOutlined,
  G2 as LoginOutlined,
  el as LogoutOutlined,
  i4 as MediaOutlined,
  Nr as MessageOutlined,
  K5 as MinusOutlined,
  ho as MobileOutlined,
  yi as MoreFilled,
  Hi as MosaicFilled,
  i7 as NonFullScreenOutlined,
  Lc as NumberInputOutlined,
  ad as OptionFilled,
  od as OptionOutlined,
  Co as OutlineTreeOutlined,
  Vr as PageAddOutlined,
  Cr as PageOutlined,
  ue as PersonOutlined,
  $e as PersonSettingOutlined,
  Oe as PersonShareOutlined,
  b7 as PlusOneOutlined,
  lt as PlusOutlined,
  it as QrcodeOutlined,
  fr as RedoOutlined,
  Q7 as ReferencesOutlined,
  nr as RefreshOutlined,
  Kr as ReturnArrowOutlined,
  D1 as RightOutlined,
  H7 as SaveOutlined,
  zn as SearchOutlined,
  Re as SettingCompleteOutlined,
  Le as SettingOutlined,
  O2 as ShareOutlined,
  Gd as StarFilled,
  j0 as StarOutlined,
  Xn as TagOutlined,
  Tl as TextAlignCenterOutlined,
  Ql as TextAlignJustifyOutlined,
  Ll as TextAlignLeftOutlined,
  Nl as TextAlignRightOutlined,
  Dc as TextInputOutlined,
  bo as TextItalicOutlined,
  Ho as TextOutlined,
  Uc as TextareaOutlined,
  ti as TipsFilled,
  D0 as TipsOutlined,
  j1 as TopOutlined,
  Io as UnderlineOutlined,
  ir as UndoOutlined,
  a2 as UnlinkOutlined,
  E5 as UnlockOutlined,
  Ge as VideoOutlined,
  si as WarningFilled,
  jt as WiFiOutlined,
  M4 as WorkflowOutlined,
  Di as manifest
};
//# sourceMappingURL=index.es.js.map
